<template>

<div align="justify" style="padding: 0;">
    <p class="h4" v-bind:style="{'border': '0px solid red', 'height': titleDiv.height + 'px', 'margin': '0'}" align="center">
        {{ tarifActive.title }} ({{ groupActive.title }})
    </p>
    <div align="justify" v-bind:style="{'padding-left': paddingLeft + 'px', 'font-size': fontSize}">
        
        <div v-bind:style="{'border': '0px solid blue', 'float': 'left', 'width': menuDiv.width + 'px', 'height': menuDiv.height + 'px'}"
            v-if="viewMode === 'large'">
            
            <div v-for="group in groups" v-bind:key="group.name" id="tarifsMenu"
                v-bind:style="{'background-color': group.backgroundColor, 'width': menuDiv.itemWidth + 'px', 'margin-right': menuDiv.itemMarginRight + 'px'}"
                v-on:click="setGroupActive(group)">
                {{ group.title }}
            </div>
            
        </div>
        
        <div id="mainDiv" v-bind:style="{'border': '0px solid blue', 'float': 'left', 'width': tarifDiv.width + 'px', 'height': tarifDiv.height + 'px', 'overflow-y': 'auto'}">
            
            <table>
                <tr v-for="row in tarifsInTable" v-bind:key="row.id">
                    <td  v-for="column in row.columns" v-bind:key="column.id" style="vertical-align: top;">
                        <div v-bind:style="{'float': 'left', 'width': itemDiv.width + 'px', 'border': '1px solid #aaaaaa', 'border-radius': '5px', 'margin-right': '3px', 'padding-right': '3px'}">
                            
                            <div v-bind:style="{'float': 'left', 'text-align': 'center', 'width': '25%', 'height': itemDiv.height + 'px'}">
                                <div v-bind:style="{'float': 'left', 'text-align': 'center', 'width': '100%', 'height': itemDiv.height * 0.1 + 'px'}">
                                </div>
                                <div v-bind:style="{'float': 'left', 'text-align': 'center', 'width': '100%', 'height': itemDiv.height * 0.5 + 'px', 'overflow-y': 'auto'}">
                                    <strong style="font-size: large;">{{ column.product.title }}</strong>
                                </div>
                                <div v-bind:style="{'float': 'left', 'text-align': 'center', 'width': '100%', 'height': itemDiv.height * 0.4 + 'px'}">
                                    <strong style="font-size: x-large; color: red;" v-if="column.product.price !== ''">{{ column.product.price }} ₽</strong>
                                </div>
                            </div>
                            
                            <div v-bind:style="{'float': 'left', 'width': '25%', 'height': itemDiv.height + 'px'}">
                                <img v-bind:src="column.product.imgSmall" v-bind:style="{'height': itemDiv.height - 2 + 'px', 'border-radius': '5px'}">
                            </div>
                            
                            <div v-bind:style="{'float': 'left', 'width': '50%', 'height': itemDiv.height + 'px', 'overflow-y': 'auto', 'text-align': 'left', 'border-radius': '5px'}">
                                <div v-html="column.product.text" style="border-radius: 5px;">
                                    
                                </div>
                            </div>

                        </div>
                    </td>
                </tr>
            </table>
            
        </div>
        
        <div v-bind:style="{'position': 'fixed', 'border': '1px solid gray', 'left': productDiv.left + 'px', 'top': productDiv.top + 'px', 'width': productDiv.width + 'px', 'height': productDiv.height + 'px', 'background-color': 'white', 'overflow-y': 'hidden', 'box-shadow': '0 0 5px rgba(122,122,122,0.5)'}"
            v-if="productDiv.visible && viewMode !== 'small'">
            
            <div v-bind:style="{'float': 'left', 'width': productDiv.img.width + 'px', 'height': productDiv.rightDiv.height + 'px', 'border-radius': '5px'}">
                <img v-bind:src="productDiv.product.img" v-bind:style="{'width': productDiv.img.width - 20 + 'px', 'border-radius': '5px'}">
            </div>
            
            <div v-bind:style="{'float': 'left', 'width': productDiv.rightDiv.width + 'px', 'height': productDiv.rightDiv.height + 'px', 'border-radius': '5px'}">
                <div v-bind:style="{'float': 'left', 'height': 100 + 'px', 'width': '100%', 'font-size': 'x-large', 'overflow-y': 'hidden'}">
                    <p style="font-size: x-large; text-align: left;">
                        {{ productDiv.product.title }}
                    </p>
                </div>
                <div v-bind:style="{'float': 'left', 'height': 50 + 'px', 'width': '100%', 'font-size': 'x-large', 'overflow-y': 'hidden'}">
                    <p style="font-weight: bold; font-size: x-large; padding-left: 10px;" v-if="productDiv.product.price !== ''">
                        {{ productDiv.product.price }} ₽
                    </p>
                </div>
                <div v-html="productDiv.product.text" v-bind:style="{'float': 'left', 'height': productDiv.rightDiv.height - 150 + 'px', 'font-size': 'large', 'overflow-y': 'auto'}">

                </div>
            </div>
            
            <div class="close" v-on:click="productDivClose()">
            </div>
            
        </div>
        
        <div v-bind:style="{'position': 'fixed', 'border': '1px solid gray', 'left': productDiv.left + 'px', 'top': productDiv.top + 'px', 'width': productDiv.width + 'px', 'height': productDiv.height + 'px', 'padding-left': '10px', 'padding-right': '10px', 'padding-top': '20px', 'background-color': 'white', 'overflow-y': 'auto', 'box-shadow': '0 0 5px rgba(122,122,122,0.5)'}"
            v-if="productDiv.visible && viewMode === 'small'">
            
            <p style="font-size: x-large; text-align: left;">
                {{ productDiv.product.title }}
            </p>
            
            <div v-bind:style="{'float': 'left', 'width': productDiv.img.width + 'px', 'border-radius': '5px'}">
                <img v-bind:src="productDiv.product.img" v-bind:style="{'width': productDiv.img.width - 20 + 'px', 'border-radius': '5px'}">
            </div>
            <div v-bind:style="{'float': 'left', 'width': productDiv.img.width - 20 + 'px', 'border-radius': '5px', 'text-align': 'center', 'margin-top': '50px'}">
                <span style="font-weight: bold; font-size: x-large;" v-if="productDiv.product.price !== ''">
                    {{ productDiv.product.price }} ₽
                </span>
            </div>
            
            <div v-html="productDiv.product.text" v-bind:style="{'float': 'left', 'margin-top': '10px', 'font-size': 'large', 'overflow-y': 'auto'}">

            </div>
            
            
        </div>
        <div class="close" v-on:click="productDivClose()" v-bind:style="{'z-index': '1000', 'right': '20px', 'top': '10px'}"
            v-if="productDiv.visible && viewMode === 'small'">
        </div>
        
    </div>
    
</div>

</template>

<script>
export default {
    name: 'PageContacts',
    data: function(){
        return{
            tarifs: [],
            tarifActive: null,
            tarifsInTable: [],
            tarifsInTableColumns: 0,
            groups: [],
            groupActive: "",
            fontSize: "",
            paddingLeft: 0,
            serviceImageWidth: 0,
            tableServiceMarginLeft: 0,
            titleDiv: {
                height: 0
            },
            menuDiv: {
                width: 0,
                height: 0,
                itemWidth: 0,
                itemMarginRight: 0,
                linkDownloadMarginTop: 0
            },
            tarifDiv: {
                width: 0,
                height: 0
            },
            itemDiv: {
                width: 0,
                height: 0
            },
            productDiv: {
                visible: false,
                product: null,
                letf: 0,
                top: 0,
                width: 0,
                height: 0,
                img: {
                    width: 0,
                    height: 0
                },
                rightDiv: {
                    width: 0,
                    height: 0
                }
            }
        };
    },
    created: function(){
        this.update();
    },
    mounted: function(){
        this.windowOnResize();
    },
    computed:{
        httpPath: function(){
            return this.$store.getters.httpPath;
        },
        httpPathCurrentPage: function(){
            return this.$store.getters.httpPathCurrentPage;
        },
        viewMode: function(){
            return this.$store.getters.viewMode;
        },
        contentWidth: function(){
            return this.$store.getters.contentWidth;
        },
        contentHeight: function(){
            return this.$store.getters.contentHeight;
        },
        contentLeft: function(){
            return this.$store.getters.contentLeft;
        },
        contentTop: function(){
            return this.$store.getters.contentTop;
        }
    },
    watch: {
        httpPathCurrentPage: function(){
            this.update();
        },
        contentWidth: function(){
            this.windowOnResize();
        },
        contentHeight: function(){
            this.windowOnResize();
        },
        contentLeft: function(){
            this.windowOnResize();
        }
    },
    methods: {
        windowOnResize: function(){
            
            this.fontSize = "medium";
            this.paddingLeft = 10;
            this.serviceImageWidth = 72;
            this.tableServiceMarginLeft = 0;
            
            let contentWidth = this.contentWidth - 230;
            
            this.titleDiv.height = 34;
            
            this.menuDiv.width = 200;
            this.menuDiv.height = 320;
            this.menuDiv.itemWidth = 180;
            this.menuDiv.itemMarginRight = 0;
            this.menuDiv.linkDownloadMarginTop = 20;
            
            this.tarifDiv.width = contentWidth;
            this.tarifDiv.height = this.contentHeight - this.titleDiv.height - 5;
            
            //this.tarifsInTableColumns = 4;
            this.tarifsInTableColumns = 1;
            
            this.productDiv.left = this.contentLeft + 10;
            this.productDiv.top = this.contentTop + 10;
            this.productDiv.width = this.contentWidth - 12;
            this.productDiv.height = this.contentHeight - 12;
            
            this.productDiv.img.width = this.productDiv.width / 2 - 10;
            this.productDiv.rightDiv.width = this.productDiv.width / 2 - 10;
            this.productDiv.rightDiv.height = this.productDiv.height - 10;
            
            this.itemDiv.width = contentWidth - 28;
            this.itemDiv.height = 220;
            
            if(this.viewMode === "medium"){
                
                this.paddingLeft = 0;
                
                contentWidth = this.contentWidth - 10;
                
                //this.menuDiv.width = contentWidth;
                //this.menuDiv.height = 120;
                //this.menuDiv.itemWidth = 240;
                //this.menuDiv.itemMarginRight = 20;
                //this.menuDiv.linkDownloadMarginTop = 0;
                this.menuDiv.height = 0;
                
                this.tarifDiv.width = contentWidth;
                this.tarifDiv.height = this.contentHeight - this.titleDiv.height - this.menuDiv.height - 5;
                
                //this.tarifsInTableColumns = 3;
                this.tarifsInTableColumns = 1;
                
                this.itemDiv.width = contentWidth - 18;
                this.itemDiv.height = 220;
                
            }
            
            if(this.viewMode === "small"){
                
                this.fontSize = "small";
                
                this.paddingLeft = 0;
                
                this.serviceImageWidth = 0;
                
                this.tableServiceMarginLeft = -15;
                
                contentWidth = this.contentWidth - 10;
                
                //this.menuDiv.width = contentWidth;
                //this.menuDiv.height = 110;
                //this.menuDiv.itemWidth = contentWidth / 3 - 10;
                //this.menuDiv.itemMarginRight = 10;
                //this.menuDiv.linkDownloadMarginTop = 0;
                this.menuDiv.height = 0;
                
                this.tarifDiv.width = contentWidth;
                this.tarifDiv.height = this.contentHeight - this.titleDiv.height - this.menuDiv.height - 5;
                
                //this.tarifsInTableColumns = parseInt( this.tarifDiv.width / (230 + 15) );
                this.tarifsInTableColumns = 1;
                
                this.itemDiv.width = contentWidth - 18;
                this.itemDiv.height = 220;
                
            }
            
            this.updateTarifsInTable();
            
        },
        update: function(){
            
            let goods = [];
            
            goods.push({
                name: "1С:Бухгалтерия 8. Базовая для 1",
                title: "1С:Бухгалтерия 8. Базовая для 1",
                group: "bp",
                imgSmall: "/img/1c/goods/1c/bp-base-for-one-small.jpg",
                img: "/img/1c/goods/1c/bp-base-for-one.jpg",
                price: "3 000",
                text: '«1С:Бухгалтерия. Базовая версия для 1» — электронный вариант поставки базовой версии «1С:Бухгалтерии 8», рассчитанный на обслуживание одного предприятия или ИП с привязкой к его ИНН. Этот продукт оптимально подойдет для небольшого бизнеса, где с программой будет работать один пользователь и не потребуется адаптация к особенностям конкретного предприятия.<br><br>Электронная поставка включает в себя дистрибутив в виде zip-архива, регистрационный номер, пинкод для активации программы и регистрации на портале «1С:ИТС», документацию в электронном виде. Работа с «1С:Бухгалтерией. Базовой версией для 1» возможна сразу после скачивания дистрибутива и установки программы на компьютер.<br><br>Также пользователь получает доступ к сервису «1С-Отчетность», который позволят отправлять регламентированную отчетность в государственные органы через Интернет.<br><br>Версия «1С:Бухгалтерия. Базовая версия для 1» имеет ряд ограничений:<br>ведение учета поддерживается только для одной организации (одного ИНН);<br>одновременно с одной информационной базой может работать только один пользователь;<br>не поддерживается изменение конфигурации пользователем, можно применять только типовую конфигурацию и устанавливать ее обновления;<br>не поддерживается работа в варианте «клиент-сервер»;<br>не поддерживается работа в режиме веб-клиента;<br>работа в режиме тонкого клиента возможна только с файловой информационной базой;<br>не поддерживается работа распределенных информационных баз;<br>не поддерживаются COM-соединение и Automation-сервер.'
            });
            
            goods.push({
                name: "1С: Бухгалтерия базовая (электронная поставка)",
                title: "1С: Бухгалтерия базовая (электронная поставка)",
                group: "bp",
                imgSmall: "/img/1c/goods/1c/bp-base-small.jpg",
                img: "/img/1c/goods/1c/bp-base.jpg",
                price: "4 900",
                text: 'Программа «1С:Бухгалтерия базовая» представляет собой готовое решение для автоматизации бухгалтерского и налогового учета организаций и индивидуальных предпринимателей. Особенности этой версии:<br>учет в отдельных информационных базах, установленных на одном компьютере;<br>общая система налогообложения, УСН, ЕНВД, патентная система (для ИП);<br>строгое соответствие законодательству, оперативное отражение изменений в учете и отчетности;<br>широкие возможности пользовательской настройки, позволяющие самостоятельно настраивать методики учета без программирования;<br>разработана на технологической платформе нового поколения «1С:Бухгалтерия базовая» рекомендуется для организаций, в которых с программой работает один бухгалтер, а также для ИП, применяющих общую, упрощенную или патентную систему налогообложения.'
            });
            
            goods.push({
                name: "1С:Бухгалтерия ПРОФ (электронная поставка)",
                title: "1С:Бухгалтерия ПРОФ (электронная поставка)",
                group: "bp",
                imgSmall: "/img/1c/goods/1c/bp-prof-small.jpg",
                img: "/img/1c/goods/1c/bp-prof.jpg",
                price: "23 000",
                text: '«1C:Бухгалтерия 8» — это профессиональный инструмент бухгалтера, с помощью которого можно вести бухгалтерский и налоговый учет, готовить и сдавать обязательную отчетность. Программа объединила в себе все достижения предыдущих версий и новые решения, основанные на опыте практической работы бухгалтеров сотен тысяч предприятий и организаций.<br><br>Понятный учет в соответствии с законодательством и потребностями бизнеса, экономия времени при расчетах налогов, оформлении документов и хозяйственных операций, эффективная поддержка пользователей в сочетании с высоким комфортом работы — лишь некоторые ключевые особенности «1C:Бухгалтерии 8».'
            });
            
            goods.push({
                name: "1С:Зарплата и управление персоналом 8. Базовая (электронная поставка)",
                title: "1С:Зарплата и управление персоналом 8. Базовая (электронная поставка)",
                group: "zup",
                imgSmall: "/img/1c/goods/1c/zup-base-small.jpg",
                img: "/img/1c/goods/1c/zup-base.jpg",
                price: "11 100",
                text: 'Программа предназначена для автоматизации расчета заработной платы и реализации кадровой политики в небольших компаниях, где с программой работает один пользователь и ее не нужно адаптировать к особенностям конкретного предприятия. Это готовое решением с широкими возможностями пользовательской настройки, которые позволяют самостоятельно настраивать методики расчета без программирования.'
            });
            
            goods.push({
                name: "1С:Зарплата и управление персоналом ПРОФ (электронная поставка)",
                title: "1С:Зарплата и управление персоналом ПРОФ (электронная поставка)",
                group: "zup",
                imgSmall: "/img/1c/goods/1c/zup-prof-small.jpg",
                img: "/img/1c/goods/1c/zup-prof.jpg",
                price: "39 700",
                text: '1С:Зарплата и управление персоналом 8 ПРОФ (1С ЗУП) предназначена для комплексной автоматизации кадрового учета и расчета заработной платы на небольших и средних предприятиях, в том числе имеющих сложную юридическую структуру. Программный продукт в первую очередь ориентирован на задачи кадровых служб и бухгалтерии, ведущих регламентированный учет и расчеты с персоналом.<br><br>1С:Зарплата и управление персоналом 8 ПРОФ (1С ЗУП) - это готовое к работе решение, в котором учтены требования законодательства и реальная практика работы предприятий. Программа позволяет автоматизировать следующие задачи:<br><br>- расчет заработной платы;<br><br>- исчисление регламентированных законодательством налогов и взносов с фонда оплаты труда;<br><br>- отражение начисленной зарплаты и налогов в затратах предприятия;<br><br>- управление денежными расчетами с персоналом, включая депонирование;<br><br>- учет кадров и анализ кадрового состава;<br><br>- автоматизация кадрового делопроизводства.'
            });
            
            goods.push({
                name: "1С:Управление торговлей Базовая (электронная поставка)",
                title: "1С:Управление торговлей Базовая (электронная поставка)",
                group: "trade",
                imgSmall: "/img/1c/goods/1c/trade-base-small.jpg",
                img: "/img/1c/goods/1c/trade-base.jpg",
                price: "10 000",
                text: 'Программный продукт «1С:Предприятие 8. Управление торговлей» предназначен для автоматизации оперативного и управленческого учета, анализа и планирования торговых операций, повышения эффективности управления современным торговым предприятием.<br><br>Программа «1С:Управление торговлей 8» обладает расширенными функциональными возможностями по сравнению с 1С:Торговля и Склад 7.7 и позволяет автоматизировать следующие направления деятельности:<br><br>управление продажами (оптовая, розничная, комиссионная торговля);<br>управление поставками;<br>управление складскими запасами (включает веб-приложение «Удаленный склад»);<br>управление заказами;<br>управление отношениями с клиентами (CRM);<br>управление товарооборотом предприятия;<br>планирование продаж и закупок;<br>анализ цен и управление ценовой политикой;<br>рапорт руководителю (мониторинг и анализ показателей деятельности предприятия);<br>подключение всех видов торгового оборудования.'
            });
            
            goods.push({
                name: "1С:Управление торговлей ПРОФ (электронная поставка)",
                title: "1С:Управление торговлей ПРОФ (электронная поставка)",
                group: "trade",
                imgSmall: "/img/1c/goods/1c/trade-prof-small.jpg",
                img: "/img/1c/goods/1c/trade-prof.jpg",
                price: "39 700",
                text: '«1С:Управление торговлей 8» — это современный инструмент для повышения эффективности бизнеса торгового предприятия. Программа позволяет в комплексе автоматизировать задачи оперативного и управленческого учета, анализа и планирования торговых операций, обеспечивая тем самым эффективное управление современным торговым предприятием.'
            });
            
            goods.push({
                name: "1С:Управление нашей фирмой 8. Базовая версия. (электронная поставка)",
                title: "1С:Управление нашей фирмой 8. Базовая версия. (электронная поставка)",
                group: "unf",
                imgSmall: "/img/1c/goods/1c/unf-base-small.jpg",
                img: "/img/1c/goods/1c/unf-base.jpg",
                price: "7 000",
                text: '1С:Управление нашей фирмой 8. Базовая версия — система, которую можно оперативно запустить в эксплуатацию, а при изменении структуры и размеров предприятия, подходов к управлению или организации работ перенастроить без существенных затрат времени и материальных ресурсов. Базовая версия используется предпринимателями и управляющими для ведения управленческого учета на одном компьютере. Эта версия дает готовое комплексное решение для небольшого предприятия, составляет нефискальный учет, контроль, планирование и анализ. Проводит подключение торгового оборудования.<br><br>Обзор на программное обеспечение 1С: Управление нашей фирмой 8. Базовая версия<br>Программное обеспечение 1С: Управление нашей фирмой 8. Базовая версия ー ПО для ведения учета в малом бизнесе. Система предназначена для работы с одного компьютера или на облачном сервере с возможностью передачи информации из интернет-ресурса на ПК и обратно. 1С: Управление нашей фирмой 8. Базовая версия подходит для организаций розничной и оптовой торговли, производственных и сервисных компаний, для интернет-магазинов. ПО работает с патентной системой налогообложения и ЕНВД.'
            });
            
            goods.push({
                name: "1С:Управление нашей фирмой ПРОФ (электронная поставка)",
                title: "1С:Управление нашей фирмой ПРОФ (электронная поставка)",
                group: "unf",
                imgSmall: "/img/1c/goods/1c/unf-prof-small.jpg",
                img: "/img/1c/goods/1c/unf-prof.jpg",
                price: "30 600",
                text: '"1С:Управление нашей фирмой 8" (УНФ) – это готовое решение для автоматизации оперативного управления на предприятиях малого бизнеса.<br><br>В программе реализовано все самое необходимое для ведения оперативного учета, контроля, анализа и планирования на предприятии. Решение не перегружено излишним функционалом, его можно легко настроить на особенности организации управления и учета в компании – это обеспечивает возможность "быстрого старта" и удобство ежедневной работы.<br><br>УНФ помогает повысить эффективность работы компании, предоставляя владельцам и руководителям широкий спектр инструментов для управления, а сотрудникам – новые возможности для продуктивной ежедневной работы.'
            });
            
            goods.push({
                name: "1С:Розница 8. Базовая версия (электронная поставка)",
                title: "1С:Розница 8. Базовая версия (электронная поставка)",
                group: "retail",
                imgSmall: "/img/1c/goods/1c/retail-base-small.jpg",
                img: "/img/1c/goods/1c/retail-base.jpg",
                price: "4 900",
                text: '«1С:Розница 8. Базовая версия» разработана для розничных торговых точек, в которых не требуется доработка стандартного решения под особенности учета предприятия.<br><br>Программа помогает автоматизировать учет денежных средств и товаров как в отдельных магазинах, так и магазинах, входящих в распределенную сеть розничного торгового предприятия.<br><br>Для программного продукта «1С:Розница 8. Базовая версия» предусмотрена возможность подключения торгового оборудования и штрихкодирование.<br><br>Программа «1С:Розница 8. Базовая версия» помогает автоматизировать оперативный и управленческий учет движения товаров и денежных средств в розничных одиночных магазинах (торговых точках).<br><br>Данная версия соответствует всем актуальным изменениям и требованиям законодательства РФ.'
            });
            
            goods.push({
                name: "1С:Розница 8 ПРОФ (электронная поставка)",
                title: "1С:Розница 8 ПРОФ (электронная поставка)",
                group: "retail",
                imgSmall: "/img/1c/goods/1c/retail-prof-small.jpg",
                img: "/img/1c/goods/1c/retail-prof.jpg",
                price: "23 000",
                text: "1С:Розница 8 — полностью автоматизирует торговую деятельность магазинов и розничных торговых точек, в том числе объединенных в торговую сеть. Поддерживает подключение торгового оборудования (сканеров, касс, фискальных регистраторов, принтеров чеков и этикеток, ТСД, эквайринга и др.). Настраивается индивидуально под любую торговую точку."
            });
            
            goods.push({
                name: "1С: Клиентская лицензия на 1 рабочее место (электронная поставка)",
                title: "1С: Клиентская лицензия на 1 рабочее место (электронная поставка)",
                group: "lic",
                imgSmall: "/img/1c/goods/1c/lic-client-small.jpg",
                img: "/img/1c/goods/1c/lic-client.jpg",
                price: "9 400",
                text: 'Для работы в многопользовательском режиме необходимо наличие у пользователей клиентских лицензий «1С:Предприятие 8». Данные лицензии предназначены для работы с конфигурациями: 1С:Управление торговлей, 1С:Бухгалтерия, 1С:Зарплата и управление персоналом, 1С:Комплексная автоматизация, 1С:Розница и другими.'
            });
            
            goods.push({
                name: "1С:Предприятие 8.3. Сервер МИНИ на 5 подключений (электронная поставка)",
                title: "1С:Предприятие 8.3. Сервер МИНИ на 5 подключений (электронная поставка)",
                group: "lic",
                imgSmall: "/img/1c/goods/1c/server-mini-5-small.jpg",
                img: "/img/1c/goods/1c/server-mini-5.jpg",
                price: "21 300",
                text: "Продукт предназначен для небольших организаций, а также средних и крупных компаний с филиалами. С появлением данного продукта клиент-серверный вариант работы \"1С:Предприятия 8\" становится более доступным для автоматизации небольших рабочих групп и может служить альтернативой файловому варианту развертывания информационной базы.<br><br>Сервер МИНИ можно использовать, например, для автоматизации кассового терминала, где необходимо обеспечить повышенный уровень отказоустойчивости, а также небольшого офиса или торговой точки с количеством рабочих мест не более пяти.<br><br>Продукт \"1С:Предприятие 8.3. Сервер МИНИ на 5 подключений\" предназначен для использования с информационными базами, работающими на платформе \"1С:Предприятие\" версии 8.3.4 и выше. Данная лицензия на сервер \"1С:Предприятия\" может использоваться с клиентскими лицензиями \"1С:Предприятия 8\" уровня ПРОФ или КОРП с программной или аппаратной защитой."
            });
            
            goods.push({
                name: "1С-Отчётность. Тариф 'Основной' на 1 год для юридического лица (для Республики Коми)",
                title: "1С-Отчётность. Тариф 'Основной' на 1 год для юридического лица (для Республики Коми)",
                group: "1c-otchetnost",
                imgSmall: "/img/1c/goods/1c/1С-Отчётность для юридического лица-small.jpg",
                img: "/img/1c/goods/1c/1С-Отчётность для юридического лица.jpg",
                price: "7 600",
                text: "Настройка сервиса 1С-Отчётность для Юридического Лица<br><br>Возможности сервиса:<br>- сдача отчетности во все контролирующие органы: ФНС, ПФР, ФСС, Росстат, Росалкогольрегулирование, Росприроднадзор, ФТС и Банк России;<br>- онлайн-проверка регламентированной отчетности перед отправкой в контролирующие органы;<br>- отправка в контролирующие органы отчетов, подготовленных в других программах;<br>- неформализованная переписка с ФНС, ПФР и Росстат;<br>- сверки с налоговой (запросы ИОН);<br>- сверки с ПФР (запросы ИОС);<br>- отправка реестров больничных листов в ФСС;<br>- получение требований и уведомлений из контролирующих органов;<br>оповещение о поступивших требованиях ФНС через «1С-Коннект» и мессенджер Viber;<br>- отправка электронных документов в ответ на требования ФНС;<br>удобный инструмент подготовки ответа на требование ФНС о представлении пояснений к налоговой декларации;<br>- получение выписок из ЕГРЮЛ/ЕГРИП, с электронной подписью ФНС;<br>формирование пакетов с отчетностью в формате для банков и прочих получателей;<br>- ретроконверсия (процесс перевода из ПФР бумажного архива в электронный вид);<br>- отправка уведомлений о контролируемых сделках;<br>сохранение архива документооборота с контролирующими органами за предыдущие периоды в онлайн «Личный кабинет» при переходе из другого сервиса;<br>- автоматизированная диагностика предупреждает проблемы в работе сервиса;<br>федеральная круглосуточная техническая поддержка пользователей"
            });
            
            goods.push({
                name: "1С-Отчётность. Тариф 'Основной' на 1 год для ИП (для Республики Коми)",
                title: "1С-Отчётность. Тариф 'Основной' на 1 год для ИП (для Республики Коми)",
                group: "1c-otchetnost",
                imgSmall: "/img/1c/goods/1c/1С-Отчётность для ИП-small.jpg",
                img: "/img/1c/goods/1c/1С-Отчётность для ИП.jpg",
                price: "2 800",
                text: "Настройка сервиса 1С-Отчётность для Индивидуального Предпринимателя<br><br>Возможности сервиса:<br>- сдача отчетности во все контролирующие органы: ФНС, ПФР, ФСС, Росстат, Росалкогольрегулирование, Росприроднадзор, ФТС и Банк России;<br>- онлайн-проверка регламентированной отчетности перед отправкой в контролирующие органы;<br>- отправка в контролирующие органы отчетов, подготовленных в других программах;<br>- неформализованная переписка с ФНС, ПФР и Росстат;<br>- сверки с налоговой (запросы ИОН);<br>- сверки с ПФР (запросы ИОС);<br>- отправка реестров больничных листов в ФСС;<br>- получение требований и уведомлений из контролирующих органов;<br>оповещение о поступивших требованиях ФНС через «1С-Коннект» и мессенджер Viber;<br>- отправка электронных документов в ответ на требования ФНС;<br>удобный инструмент подготовки ответа на требование ФНС о представлении пояснений к налоговой декларации;<br>- получение выписок из ЕГРЮЛ/ЕГРИП, с электронной подписью ФНС;<br>формирование пакетов с отчетностью в формате для банков и прочих получателей;<br>- ретроконверсия (процесс перевода из ПФР бумажного архива в электронный вид);<br>- отправка уведомлений о контролируемых сделках;<br>сохранение архива документооборота с контролирующими органами за предыдущие периоды в онлайн «Личный кабинет» при переходе из другого сервиса;<br>- автоматизированная диагностика предупреждает проблемы в работе сервиса;<br>федеральная круглосуточная техническая поддержка пользователей"
            });
            
            let tarif =
            this.tarifAdd({
                url: "продукция-1с",
                name: "Продукция1С",
                title: "Продукция 1С",
                goods: goods
            });
            
            goods = [];
            
            goods.push({
                name: "POScenter-А7L-Ф без ФН",
                title: "POScenter-А7L-Ф без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/POScenter-А7L-Ф-small.jpg",
                img: "/img/1c/goods/kkt-mobile/POScenter-А7L-Ф.jpg",
                price: "",
                text: 'POSCENTER-А7L-Ф — компактный смарт-терминал, созданный для автоматизации продаж в кассовой зоне. Применим во всех направлениях розничной торговли и услуг, общепите, в гостиницах, кафе и ресторанах. Создан на базе операционной системы Android с поддержкой последних релизов товароучетных программ. Оснащен принтером, который имеет высокую скорость печати (220 мм/с ). Устройство взаимодействует со всеми зарегистрированными ОФД и передает данные через беспроводные интерфейсы (Bluetooth и Wi-Fi). Для подключения периферии присутствуют необходимые разъемы (USB, RG1).'
            });
            
            goods.push({
                name: "ШТРИХ КАРТ-Ф (Ilexx Lite) без ФН",
                title: "ШТРИХ КАРТ-Ф (Ilexx Lite) без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/ШТРИХ КАРТ-Ф (Ilexx Lite) без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/ШТРИХ КАРТ-Ф (Ilexx Lite) без ФН.jpg",
                price: "",
                text: 'Автономная онлайн-касса Штрих-Карт-Ф с приемом банковских карт и способностью работать с бесконтактной системой оплаты: Android Pay, Apple Pay, Samsung Pay и прочие сервисы оплаты.'
            });
            
            goods.push({
                name: "ШТРИХ КАРТ-Ф (Торговля онлайн) без ФН",
                title: "ШТРИХ КАРТ-Ф (Торговля онлайн) без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/ШТРИХ КАРТ-Ф (Торговля онлайн) без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/ШТРИХ КАРТ-Ф (Торговля онлайн) без ФН.jpg",
                price: "",
                text: 'Автономная онлайн-касса Штрих-Карт-Ф с приемом банковских карт и способностью работать с бесконтактной системой оплаты: Android Pay, Apple Pay, Samsung Pay и прочие сервисы оплаты.'
            });
            
            goods.push({
                name: "ШТРИХ СМАРТПОС-Ф МИНИ (Ilexx Lite) без ФН",
                title: "ШТРИХ СМАРТПОС-Ф МИНИ (Ilexx Lite) без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/ШТРИХ СМАРТПОС-Ф МИНИ (Ilexx Lite) без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/ШТРИХ СМАРТПОС-Ф МИНИ (Ilexx Lite) без ФН.jpg",
                price: "",
                text: 'Мобильная Android-касса с сенсорным экраном с диагональю 5,5 дюймов, встроенным принтером чеков и аккумулятором для автономной работы. Бюджетное решение для стационарной розницы (сферы услуг, небольших магазинов и точек фаст-фуда), а также для мобильной торговли, онлайн-магазинов и курьерских служб.<br><br>Яркий экран 5.5 дюймов с матрицей IPS высокого разрешения HD 720х1280 точек, высоким качеством сборки, интуитивно понятный интерфейс кассовых программ, большой объём оперативной памяти (1 Гб) и мощная начинка — высокоскоростной четырёхядерный процессор MediaTek MTK6737 1.36 ГГц обеспечивают смарт-терминалу неоспоримое преимущество на рынке.'
            });
            
            goods.push({
                name: "Атол Sigma 10 без ФН",
                title: "Атол Sigma 10 без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/Атол Sigma 10 без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/Атол Sigma 10 без ФН.jpg",
                price: "",
                text: 'Атол Sigma 10 — смарт-терминал нового поколения с сенсорным дисплеем 10 дюймов. Применим для предприятий малого и среднего бизнеса: кафе, маленькие рестораны, бутики, небольшие магазинчики (как продуктовые, так и обычные). Скорость печати чека — 100 мм/с, ширина кассовой термоленты — 57 мм. Для отправки информации в налоговую используются стандарты Ethernet, 3G, Wi-Fi. Благодаря большому числу USB портов (4 шт) можно подключить периферийное оборудование. Pos-система совместима со всеми популярными кассовыми и товароучетными программами, разработанными для Android.'
            });
            
            goods.push({
                name: "aQsi 5Ф с эквайрингом без ФН",
                title: "aQsi 5Ф с эквайрингом без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/aQsi 5Ф с эквайрингом без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/aQsi 5Ф с эквайрингом без ФН.jpg",
                price: "",
                text: 'Онлайн-касса aQsi - решение для розничных точек торговли, предприятий общественного питания и курьерских служб.<br>Современный смарт - терминал совмещает в себе принтер чеков и сканер 1D/2D кодов, а также поддерживает подключение стороннего банковского терминала.<br><br>Отличительные особенности aQsi:<br><br>Компактные размеры и эргономичный дизайн<br>Расширенный функционал личного кабинета для оптимизации Вашего бизнеса<br>Интуитивно понятный интерфейс рабочего пространства<br>Фильтрация и поиск информации в личном кабинете<br>Возможность добавления и редактирования необходимых товаров и услуг<br>Мощный аккумулятор, обеспечивающий длительную работу без подзарядки<br>Бесплатная интеграция с любой конфигурацией 1С<br>Интеграция с сервисом Orange Data для фискализации интернет платежей'
            });
            
            goods.push({
                name: "aQsi 5Ф без эквайринга и ФН",
                title: "aQsi 5Ф без эквайринга и ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/aQsi 5Ф без эквайринга и ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/aQsi 5Ф без эквайринга и ФН.jpg",
                price: "",
                text: 'Онлайн-касса aQsi - решение для розничных точек торговли, предприятий общественного питания и курьерских служб.<br>Современный смарт - терминал совмещает в себе принтер чеков и сканер 1D/2D кодов, а также поддерживает подключение стороннего банковского терминала.<br><br>Отличительные особенности aQsi:<br><br>Компактные размеры и эргономичный дизайн<br>Расширенный функционал личного кабинета для оптимизации Вашего бизнеса<br>Интуитивно понятный интерфейс рабочего пространства<br>Фильтрация и поиск информации в личном кабинете<br>Возможность добавления и редактирования необходимых товаров и услуг<br>Мощный аккумулятор, обеспечивающий длительную работу без подзарядки<br>Бесплатная интеграция с любой конфигурацией 1С<br>Интеграция с сервисом Orange Data для фискализации интернет платежей'
            });
            
            goods.push({
                name: "Нева-01-Ф без ФН",
                title: "Нева-01-Ф без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/Нева-01-Ф без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/Нева-01-Ф без ФН.jpg",
                price: "",
                text: 'ККТ Нева - это ККМ с большим и ярким дисплеем диагональю 7 дюймов и печатающим механизмом. Выход в Интернет обеспечивается Wi-Fi модулем и LAN- разъемом или же с помощью встроенного GSM-модема, через которые можно передавать информацию в ОФД, ЕГАИС и отправлять чеки покупателям на телефон и электронную почту.'
            });
            
            goods.push({
                name: "ШТРИХ СМАРТПОС-Ф МИНИ (Торговля онлайн) без ФН",
                title: "ШТРИХ СМАРТПОС-Ф МИНИ (Торговля онлайн) без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/ШТРИХ СМАРТПОС-Ф МИНИ (Торговля онлайн) без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/ШТРИХ СМАРТПОС-Ф МИНИ (Торговля онлайн) без ФН.jpg",
                price: "",
                text: 'Мобильная Android-касса с сенсорным экраном с диагональю 5,5 дюймов, встроенным принтером чеков и аккумулятором для автономной работы. Бюджетное решение для стационарной розницы (сферы услуг, небольших магазинов и точек фаст-фуда), а также для мобильной торговли, онлайн-магазинов и курьерских служб.<br><br>Яркий экран 5.5 дюймов с матрицей IPS высокого разрешения HD 720х1280 точек, высоким качеством сборки, интуитивно понятный интерфейс кассовых программ, большой объём оперативной памяти (1 Гб) и мощная начинка — высокоскоростной четырёхядерный процессор MediaTek MTK6737 1.36 ГГц обеспечивают смарт-терминалу неоспоримое преимущество на рынке.'
            });
            
            goods.push({
                name: "MSPOS-E-Ф без ФН",
                title: "MSPOS-E-Ф без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/MSPOS-E-Ф без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/MSPOS-E-Ф без ФН.jpg",
                price: "",
                text: 'MSPOS-E-Ф — мобильное оборудование, предназначенное для автоматизации денежных расчетов. Применяется на предприятиях сферы торговли (включая выездную), услуг, ресторанного и гостиничного бизнеса. Техника оснащена ОС Android, сенсорным экраном, сертифицированным эквайрингом, сканером ШК. ФН прилагается в комплекте или приобретается отдельно на срок 13-36 мес. Выход в Сеть — по каналам связи 3G, 4G, Wi-Fi. Синхронизация с ПК, весами, ТСД — через порт USB и модуль Bluetooth. Чеки формируются со скоростью 75 мм/с на термоленте шириной 58 мм. Печать QR-кодов допускает интеграцию с ЕГАИС. Время автономной работы — до 48 ч.'
            });
            
            goods.push({
                name: "MSPOS-K без ФН",
                title: "MSPOS-K без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/MSPOS-K без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/MSPOS-K без ФН.jpg",
                price: "",
                text: 'ПТК MSPos-K — компактный надежный ККТ с сенсорным экраном и компьютером на основе ОС Android. Встроенный принтер поддерживает высокую скорость печати, использует ленту 80 мм шириной. Проводное подключение к сети, беспроводные интерфейсы Wi-Fi и 3G, поддержка периферийных устройств, в том числе сканеров штрих-кода. Защита от воды.'
            });
            
            goods.push({
                name: "АТОЛ Sigma 8 без ФН",
                title: "АТОЛ Sigma 8 без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/АТОЛ Sigma 8 без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/АТОЛ Sigma 8 без ФН.jpg",
                price: "",
                text: 'Программно-аппаратный комплекс Сигма 8 состоит из сенсорного экрана, мощного процессора и принтера чеков. Он удачно впишется в маленьком помещении, обеспечит полноценное рабочее место кассира и автоматизацию торговых операций.<br><br>Преимущества терминала:<br><br>Горизонтальный 8-дюймовый дисплей обеспечивает хорошую видимость информации и удобство внесения данных.<br>Предустановленное ПО на ККТ разработано с учетом специфики сферы услуг. Для расширения функционала аппарата можно загружать дополнительные приложения.<br>Это первое устройство на российском рынке, которое уже поддерживает универсальный формат фискальных данных 1.1. Основная особенность этого ФФД — счетчики в ФН, благодаря которым пользователь может смотреть аналитику по сменной выручке, суммам НДС, разным типам оплаты: кредит, предоплата, рассрочка и т.д.<br><br>ККТ выполняет весь комплекс базовых задач:<br><br>проводит расчеты за услуги и товары;<br>формирует и печатает чеки;<br>передает фискальные документы в ФНС.<br>Помимо этого пользователю доступны дополнительные возможности:<br><br>управление базой клиентов, акциями, бонусами и скидками;<br>сбор отзывов от клиентов по электронным чекам;<br>удаленный контроль над бизнесом;<br>учет продукции и расходных материалов;<br>контроль нагрузки и результатов каждого сотрудника (мастера);<br>автоматический подсчет доходов и расходов, который избавляет от рутинной работы и экономит время бухгалтера.<br>Компактный моноблок оснащен удобной подставкой, но в отличие от 10-й модели (Еда) у «восьмерки» нет функции регулирования угла наклона.'
            });
            
            goods.push({
                name: "Атол Sigma 7 без ФН",
                title: "Атол Sigma 7 без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/Атол Sigma 7 без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/Атол Sigma 7 без ФН.jpg",
                price: "",
                text: 'Атол Sigma 7 – смарт-терминал для автоматизации платежей. Имеет ОС, допускающую загрузку доп. приложений для адаптации к разным видам деятельности. Подходит для магазинов, салонов, заведений общепита, используется при выездной торговле. Система управления – посредством сенсорного дисплея. Поддерживает обмен данными с фискальными службами в онлайн-режиме через Ethernet или в зависимости от комплектации по беспроводным каналам Wi-Fi и GSM. К терминалу подключают ПК или другую периферию с помощью разъемов USB и RJ (в качестве опции доступно связь по Bluetooth). Скорость печати чеков – 100 мм/с. Используется термобумага шириной 57 мм. Гарантированный ресурс печатающей головки – не менее 50 км распечатанной ленты.'
            });
            
            goods.push({
                name: "Viki Mini без ФН",
                title: "Viki Mini без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/Viki Mini без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/Viki Mini без ФН.jpg",
                price: "",
                text: '- До 60 кнопок быстрого доступа<br>- Поддержка ЕГАИС<br>- Ограничение продаж алкоголя по времени<br>- Режим суммирующей кассы<br>- Поиск товаров по названию<br>- Дистанционная диагностика неисправностей<br>- Поиск товаров по штрихкоду<br>- Поиск товаров по артикулу<br>- Загрузка скидок из товароучетных систем<br>- Возврат произвольной позиции в чеке<br>- Разграничение прав пользователей на кассе<br>- Подключение прикассовых весов Масса-К (по USB и RS232), Штрих Слим (только USB), CAS AD и CAS ER (только RS232), CAS SWN (USB)<br>- Загрузка и выгрузка товаров в Excel<br>- Выгрузка продаж в Excel<br>- Учет продаж по отделам<br>- Вскрытие тары<br>- Обновление через интернет<br>- Ширина бумаги 57 мм<br>- Скорость печати 80 мм/сек<br>- Контрольная лента на карте microSD<br>- Количество смен в ФП: 8000<br>- Печать изображений и QR-кодов'
            });
            
            goods.push({
                name: "Viki Micro без ФН",
                title: "Viki Micro без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/Viki Micro без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/Viki Micro без ФН.jpg",
                price: "",
                text: '- До 80 кнопок быстрого доступа<br>- Ограничение продаж алкоголя по времени<br>- Режим суммирующей кассы<br>- Дистанционная диагностика неисправностей<br>- Подключение прикассовых весов Масса-К (по USB и RS232), Штрих Слим (только USB), CAS AD и CAS ER (только RS232), CAS SWN (USB)<br>- Поиск товаров по названию<br>- Поиск товаров по артикулу<br>- Загрузка скидок из товароучетных систем<br>- Возврат любой позиции в чеке<br>- Разграничение прав пользователей на кассе<br>- Загрузка и выгрузка товаров в Excel<br>- Выгрузка продаж в Excel<br>- Учет продаж по отделам<br>- Вскрытие тары<br>- Обновление через интернет<br>- USB 2.0<br>- HDMI<br>- LAN RJ45<br>- Скорость печати<br>100 мм/сек<br>- Ресурс печатающей головки 100 км<br>- Печать QR-кодов Есть<br>- Журнал операций на SD-карте<br>- Ширина печати 57 мм'
            });
            
            goods.push({
                name: "Онлайн-Касса Ф без ФН",
                title: "Онлайн-Касса Ф без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/Онлайн-Касса Ф без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/Онлайн-Касса Ф без ФН.jpg",
                price: "",
                text: '- Соответствует ФФД<br>- Передача фискальных данных в ФНС через ОФД<br>- Работа со всеми ОФД<br>- Обеспечивает передачу чеков на электронную почту или абонентский номер покупателя<br>- Ручной ввод номера телефона или электронной почты покупателя<br>- WiFi<br>- IEEE802.11b/g/n<br>- Ethernet<br>- 10/100 Мбит/с<br>- Операционная система Linux<br>- Модуль GPRS (опционально) 2G<br>- Ширина бумаги 57 мм<br>- Скорость печати 70 мм/с<br>- Печать QR-кода<br>- Ресурс печатающей головки не менее 75 км'
            });
            
            goods.push({
                name: "АТОЛ 91Ф без ФН",
                title: "АТОЛ 91Ф без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/АТОЛ 91Ф без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/АТОЛ 91Ф без ФН.jpg",
                price: "",
                text: 'Ресурс печатной головки 50 км<br>Автоотрез чека Нет, гребенка<br>Длина намотки чековой ленты 30 м<br>Диаметр рулона чековой ленты 43 мм<br>Ширина чека 58 мм<br>Количество USB 1 шт<br>Передача данных Ethernet, Wi-Fi, 3G, Bluetooth<br>Экран в дюймах 2,7"<br>Разрешение экрана 6 строк<br>Беспроводная передача данных Wi-Fi, 2G, Bluetooth, Ethernet<br>Подключение к денежному ящику —<br>Подключение к дисплею покупателя —<br>Подключение сканера штрихкодов Да<br>Подключение банковского пин-пада Да<br>Подключение к питанию Micro-USB, 5В от блока питания, АКБ типа 18650<br>Время работы от аккумклятора до 8 часов<br>Температурный режим от - 10С до +45С<br>Размеры ДЛхШРхВС 187х85х66 мм<br>Вес без чековой ленты 0,39 кг'
            });
            
            goods.push({
                name: "ЭЛВЕС-МФ 3G без ФН",
                title: "ЭЛВЕС-МФ 3G без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/ЭЛВЕС-МФ 3G без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/ЭЛВЕС-МФ 3G без ФН.jpg",
                price: "",
                text: 'Тип устройства Мобильная онлайн-касса<br>Макс. ширина бумаги, мм 57<br>Внешний диаметр рулона бумаги, мм не более 60<br>Скорость печати, мм/сек не менее 45<br>Интерфейсы RS-232, Wi-Fi (для связи с ОФД)<br>Питание от аккумулятора 6V 1200 mAh<br>Диапазон рабочих температур, °C -10°C..+40°C<br>Габариты оборудования (ШхГхВ), мм 116х232х73<br>Вес нетто, кг 0,9<br>Утилита программирования (таблицы,база) MicroConfig<br>Размер базы товаров (ПЛУ) От 300<br>Сканер штрихкодов RS-232 опционально<br>Модем GPRS (3G) опционально<br>Кабель USB-COM-ККТ опционально<br>Гарантия 12 месяцев<br>Страна производства Россия'
            });
            
            goods.push({
                name: "Эвотор 10 без ФН",
                title: "Эвотор 10 без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/Эвотор 10 без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/Эвотор 10 без ФН.jpg",
                price: "",
                text: 'Эвотор 10 — онлайн-касса с самым большим экраном в линейке. На 10-дюймовом экране удобно пробивать блюда, работать со столиками и вести клиентскую базу. Работает без подзарядки 12 часов: можно торговать в ресторане, на террасе, в палатке и на фестивале.'
            });
            
            goods.push({
                name: "Эвотор 7.3 без ФН",
                title: "Эвотор 7.3 без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/Эвотор 7.3 без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/Эвотор 7.3 без ФН.jpg",
                price: "",
                text: 'Эвотор 7.3 работает без подзарядки 14 часов и сочетает в себе функциональность, надёжность и стильный дизайн. Подойдёт тем, кому важна эстетика, чтобы касса гармонично вписалась в современный интерьер.'
            });
            
            goods.push({
                name: "Эвотор 5 line 5i SmartPOS без ФН",
                title: "Эвотор 5 line 5i SmartPOS без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/Эвотор 5 line 5i SmartPOS без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/Эвотор 5 line 5i SmartPOS без ФН.jpg",
                price: "",
                text: 'Смарт-терминал «Эвотор 5 line» — это новая линейка онлайн-касс, которая взяла лучшее от моделей «Эвотор 5» и «Эвотор 5i». Главное отличие новой линейки в том, что вы можете модернизировать более простую версию онлайн-касса до продвинутой. Например, если вам не нужен эквайринг, то выбирайте версию онлайн-кассы — 5 ST. Но если в будущем вы захотите добавить платёжный терминал, то модернизируйте 5 ST до версии с эквайрингом — 5i SmartPOS.<br>Линейка онлайн-касс «Эвотор 5 line» работает без подзарядки 12 часов, помещается в ладони и подойдёт тем, кому важна компактность, мобильность и автономность. Для версии 5i SmartPOS не нужен пинпад, потому что в смарт-терминал встроен модуль эквайринга. 5i SmartPOS принимает любые виды платежей: наличными, по карте и смартфоном.'
            });
            
            goods.push({
                name: "КАССАТКА 10 без ФН",
                title: "КАССАТКА 10 без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/КАССАТКА 10 без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/КАССАТКА 10 без ФН.jpg",
                price: "",
                text: 'Процессор Четыре ядра<br><br>Память 1 Гб ОЗУ, 8 Гб встроенный носитель<br><br>Операционная система не ниже Android 6.0<br><br>Дисплей 10“ , 1024x600, TFT<br><br>Картридер NFC<br><br>Ширина ленты 58 мм<br><br>Связь GPRS, WCDMA, Ethernet, WiFi, Bluetooth<br><br>Звук Есть<br><br>SIM 1 слот<br><br>Интерфейсы USB – 6 шт., MicroUSB – 1 шт., RJ 45 – 1 шт., RJ 11 – 1шт.<br><br>Аккумулятор 5000 мАч<br><br>Блок питания 100 – 240В'
            });
            
            goods.push({
                name: "КАССАТКА MINI без ФН",
                title: "КАССАТКА MINI без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/КАССАТКА MINI без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/КАССАТКА MINI без ФН.jpg",
                price: "",
                text: 'Процессор Четыре ядра<br><br>Память 1GB RAM; 8GB Flash, Внешняя micro SD<br><br>Операционная система Android 5.1<br><br>Вес 442 гр<br><br>Дисплей 5,5 “ , 1024x600, IPS<br><br>Картридер ISO14443 Тип А Mirafare<br><br>Термопринтер Скорость: 18 полос/сек (90 мм/с)<br><br>Ширина ленты 58 мм, диаметр 35 мм<br><br>Связь GPRS / WCDMA/ WiFi/ Bluetooth<br><br>Камера 5 Мп, с автофокусом<br><br>Звук Есть<br><br>Интерфейсы 2 USB Host, 1 micro USB, 1 RJ45, 1 SIM<br><br>Аккумулятор 7.4V, 2500mAh<br><br>Блок питания Входящее: 100-240VAC;<br>Исходящее: 5VDC, 2.5A'
            });
            
            goods.push({
                name: "КАССАТКА 7 без ФН",
                title: "КАССАТКА 7 без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/КАССАТКА 7 без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/КАССАТКА 7 без ФН.jpg",
                price: "",
                text: 'Процессор Четыре ядра<br>Память 1GB RAM. Внешняя micro SD<br>Операционная система не ниже Android 7.0<br>Дисплей 7“ , 1024x600, TFT<br>Картридер ISO14443 Тип A/B, ISO1092 (опционально)<br>Термопринтер Скорость: 18 полос/сек<br>Ширина ленты 58 мм, диаметр 50 мм<br>Связь GPRS, WCDMA, Ethernet, WiFi, Bluetooth<br>Звук Есть<br>Интерфейсы 2 USB Host, 1 micro USB, 1 RJ45<br>Аккумулятор 7.4V, 2500mAh<br>Блок питанияВходящее: 100-240VAC; Исходящее: 9VDC, 2.5A'
            });
            
            goods.push({
                name: "ЭВОТОР 7.2 без ФН",
                title: "ЭВОТОР 7.2 без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/ЭВОТОР 7.2 без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/ЭВОТОР 7.2 без ФН.jpg",
                price: "",
                text: 'Технические характеристики устройства<br>Дисплей 7”, ёмкостный тип<br>Разрешение экрана 1024х600<br>Плотность экрана 170 DPI<br>Процессор компьютера MediaTek MTK8321A, 1.3GHZ<br>Операционная система Evotor OS, версия 2<br>Объём оперативной памяти 1 Гб<br>Объём физической памяти 8 Гб<br>Дополнительная память microSD, до 32 Гб<br>Поддерживаемые беспроводные сети Wi-Fi (протокол IPv4), Bluetooth 4.0, GSM 2G, 3G<br>Навигация Нет<br>Доступ в Интернет Карта mini-SIM;<br>операторы: Мегафон, МТС, Билайн, Теле2<br>Ethernet Нет<br>Количество USB-портов для подключения внешних устройств 5 (в нижней части корпуса) + 1 (на фронтальной стороне, для подключения USB-носителя)<br>Дополнительные интерфейсы Денежный ящик<br>Камера Нет<br>Тип печатающего устройства Термопечатающий механизм<br>Скорость печати До 70 мм/с<br>Параметры печатной ленты ширина: 57 мм; макс. диаметр рулона: 54 мм; однослойная термобумага, толщина 0,06-0,1мм<br>Резак 1 стальная гребенка<br>Основные характеристики фискальной памяти* Количество записей итогов смен: 8534;<br>Количество перерегистраций: 24<br>Время сохранности информации в регистрах после выключения питания Не менее 1440 ч.<br>Срок сохранности информации в ФН Не менее 5 лет<br>Электропитание Внешний сетевой адаптер Coaxial, 24V, 1.25A<br>Аккумулятор Нет (только для безопасного отключения)<br>Время автономной работы нет<br>Габаритные размеры, мм 247 х 112 х 115<br>Вес без сетевого адаптера 1000 г<br>Эксплуатационные характеристики устройства<br>Срок службы Не менее 10 лет<br>Ресурс печатающего устройства 50 км<br>Климатические условия для эксплуатации Температура: от 0 до +45 °С;<br>Относительная влажность: не выше 85% при температуре +35 °С<br>Климатические условия для хранения и транспортировки<br>(в заводской упаковке) Температура: от -30 до +45 °С;<br>Относительная влажность: не выше 85% при температуре +35 °С'
            });
            
            goods.push({
                name: "ЭВОТОР 5 line ST без ФН",
                title: "ЭВОТОР 5 line ST без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/ЭВОТОР 5 line ST без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/ЭВОТОР 5 line ST без ФН.jpg",
                price: "",
                text: 'Технические характеристики устройства<br>Модель смарт-терминала Эвотор 5 line ST<br>Дисплей 5,5”, ёмкостный тип<br>Разрешение экрана 1280х720<br>Плотность экрана 267 DPI<br>Процессор компьютера MediaTek MTK8321A, 1.3GHZ<br>Операционная система Evotor OS, версия 3<br>Объём оперативной памяти 1 Гб<br>Объём физической памяти 8 Гб<br>Дополнительная память Нет<br>Поддерживаемые беспроводные сети Wi-Fi (протокол IPv4), Bluetooth 4.0, GSM 2G, 3G<br>Навигация GPS<br>Доступ в Интернет Карта mini-SIM;<br>операторы: Мегафон, МТС, Билайн, Теле2<br>Ethernet Нет<br>Количество USB-портов для подключения внешних устройств 1 (с левой стороны корпуса)<br>Дополнительные интерфейсы нет<br>Камера Две камеры по 5 Мп<br>Тип печатающего устройства Термопечатающий механизм<br>Скорость печати До 50 мм/с<br>Ширина печатной ленты 57 мм<br>Диаметр чековой ленты до 40 мм<br>Резак 2 пластиковые гребёнки<br>Основные характеристики фискальной памяти Нет<br>Время сохранности информации в регистрах после выключения питания Не менее 1440 ч.<br>Срок сохранности информации в ФН Не менее 5 лет<br>Электропитание Внешний блок питания с кабелем Jack 2,5 5V,2,1A<br>Аккумулятор 2600 мА·ч х 2<br>Время автономной работы 6-12 ч<br>Габаритные размеры, мм 208,4х86х50<br>Вес без сетевого адаптера 400 г<br>Эксплуатационные характеристики устройства<br>Время непрерывной работы (от электросети) Не менее 16 ч<br>Срок службы Не менее 5 лет<br>Ресурс печатающего устройства 100 км<br>Климатические условия для эксплуатации Температура: от 0 до +45 °С;<br>Относительная влажность: не выше 85% при температуре +30 °С<br>Климатические условия для хранения и транспортировки<br>(в заводской упаковке) Температура: от -40 до +50 °С;<br>Относительная влажность: не выше 90% при температуре +35 °С'
            });
            
            goods.push({
                name: "ШТРИХ-СМАРТПОС-Ф без ФН",
                title: "ШТРИХ-СМАРТПОС-Ф без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/ШТРИХ-СМАРТПОС-Ф без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/ШТРИХ-СМАРТПОС-Ф без ФН.jpg",
                price: "",
                text: 'Предустановленное программное обеспечение<br>Смарт-терминал поставляется на выбор с предустановленной кассовой программой Illex Lite или программным решением Торговля.онлайн (кассовое ПО и и мощное облачное товароучётное ПО, сравнимое по своим возможностям с 1С).<br>Кассовая программа Illex Lite (разработка ЦОР «ШТРИХ-М») это:<br>Готовое кассовое решение без ежемесячных платежей<br>Удобная работа с каталогом товаров (быстрое заведение товара прямо на кассе)<br>Бесплатная интеграция с внешними товароучетными системами от ЦОР «ШТРИХ-М» и 1С<br>Осуществление продаж по свободной цене<br>Прием оплаты наличными и картами<br>Оформление возвратов по номеру чека и без, сторнирование продаж<br>Печать X- и Z-отчётов, оформление чеков коррекции<br>Мониторинг касс, аналитика продаж и контроль за действиями кассиров<br>Работа с ЕГАИС для продажи алкоголя<br><br>Программное решение Торговля.онлайн (разработка компании Septagon) это:<br><br>Готовое решение для розничного магазина (касса «под ключ» и мощная товароучетная программа)<br>Полностью бесплатное решение (никакой платы за регистрацию и никаких ежемесячных платежей)<br>Соответствие требованиям 54-ФЗ<br>Аналитика продаж, торговый учет (FIFO, LIFO, FEFO)<br>Несколько магазинов в одной программе<br>Одна программа для нескольких юрлиц<br>Неограниченное количество пользователей в одной программе<br>Работа с ЕГАИС для продажи алкоголя<br><br>Открытая платформа<br><br>Кроме того, ККТ «ШТРИХ-СМАРТПОС-Ф» - единственная на рынке Android-касса с открытой платформой и возможностью установки сторонних кассовых и иных специализированных приложений через Google Play или в виде apk. Перечень поддерживаемых кассовых решений (как платных, так и бесплатных) ниже:<br>aQsi Касса<br>EKAM<br>БИФИТ.Касса<br>Subtotal<br>1С:Мобильная касса<br><br>Технические характеристики<br>Тип ККТ Смарт-терминал на ОС Android<br>Дисплей кассира Встроенный<br>Тип дисплея кассира TFT-LCD сенсорный (емкостной мультитач)<br>Размер и разрешение дисплея кассира 7" (TFT 600x1024)<br>Процессор MediaTek MT8321 Cortex A7 (4 ядра)<br>Частота процессора 1,3 ГГц<br>Оперативная память (ОЗУ) 1 Гб<br>Накопитель Flash 8 Гб (есть слот для microSD-карты)<br>Печатающее устройство Встроенный термопринтер<br>Бумага 57 мм<br>Скорость печати – до 90 мм/сек (18 строк/сек)<br>Ручное отделение чека (металлическая гребенка)<br>Аккумулятор 2500 мА*ч (Li-Ion)<br>Интерфейсные разъёмы 2xUSB Type A (host), 1xEthernet (LAN), 1xmicroUSB (device)<br>Беспроводные интерфейсы Wi-Fi 802.11b/g/n, Bluetooth 4.0<br>2G (900 МГц/1800 МГц), 3G (900 МГц/2100 МГц)<br>Операционная система Android 7.0<br>Кассовое программное обеспечение Предустановленное БЕСПЛАТНОЕ кассовое ПО на Android:<br>- Illex Lite<br>- Торговля.онлайн<br>Диапазон рабочих температур +10°C..+35°C<br>Диапазон температур хранения +5°C..+35°C<br>Относительная влажность (без конденсата), Рабочая: не более 80% (при +35°C)<br>Хранения: не более 85%<br>Масса (без адаптера) не более 0,9 кг<br>Габариты (ШхГхВ) 118х255х80 мм<br>Гарантия 12 месяцев'
            });
            
            goods.push({
                name: "ЭЛВЕС-МФ без ФН",
                title: "ЭЛВЕС-МФ без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/ЭЛВЕС-МФ без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/ЭЛВЕС-МФ без ФН.jpg",
                price: "",
                text: 'Тип устройства Мобильная онлайн-касса<br>Макс. ширина бумаги, мм 57<br>Внешний диаметр рулона бумаги, мм не более 60<br>Скорость печати, мм/сек не менее 45<br>Интерфейсы RS-232, Wi-Fi (для связи с ОФД)<br>Питание от аккумулятора 6V 1200 mAh<br>Диапазон рабочих температур, °C -10°C..+40°C<br>Габариты оборудования (ШхГхВ), мм 116х232х73<br>Вес нетто, кг 0,9<br>Утилита программирования (таблицы,база) MicroConfig<br>Размер базы товаров (ПЛУ) От 300<br>Сканер штрихкодов RS-232 опционально<br>Модем GPRS (3G) опционально<br>Кабель USB-COM-ККТ опционально<br>Гарантия 12 месяцев<br>Страна производства Россия'
            });
            
            goods.push({
                name: "Атол 92Ф без ФН",
                title: "Атол 92Ф без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/Атол 92Ф без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/Атол 92Ф без ФН.jpg",
                price: "",
                text: 'Способ печати Термопечать<br>Передача данных в ОФД Wi-Fi, 2G, Bluetooth, Ethernet<br>Качество печати, dpi 203<br>Подключение к ПК Micro USB<br>Скорость печати мм/с 50<br>Подключение денежного ящика Нет<br>Ресурс печатающего механизма, км 50<br>Количество usb-портов 2<br>Автоотрез Нет<br>Размеры, мм 208 х 103 х 66<br>Количество символов в строке от 24 до 42 (при бумаге 58 мм)<br>Вес, кг 0,5<br>Подключение сканера штрих-кодов Да<br>Подключение банковского пин-пада Да<br>Цвет Черный<br>Питание USB, 5В, 1А от блока питания, АКБ типа 18650<br>Температурный режим -10С - +45С<br>Личный кабинет https://lk.atol.ru/<br>Возможность подключения - сканера штрихкода<br>- электронных весов АТОЛ MARTA'
            });
            
            goods.push({
                name: "Атол 91Ф Lite без ФН",
                title: "Атол 91Ф Lite без ФН",
                group: "kkt-mobile",
                imgSmall: "/img/1c/goods/kkt-mobile/Атол 91Ф Lite без ФН-small.jpg",
                img: "/img/1c/goods/kkt-mobile/Атол 91Ф Lite без ФН.jpg",
                price: "",
                text: 'Способ печати Термопечать<br>Передача данных в ОФД Wi-Fi, 2G, Ethernet<br>Качество печати, dpi 203<br>Подключение к ПК Micro USB<br>Скорость печати мм/с 50<br>Подключение сканера штрих-кодов Да<br>Подключение банковского пин-пада Да<br>Подключение электронных весов АТОЛ MARTA Да<br>Размеры 85х66х187<br>Количество символов в строке От 32 до 42 (при бумаге 58 мм)<br>Вес, кг 0,39<br>Программное обеспечение АТОЛ Драйвер ККТ для первоначальной настройки.<br>Личный кабинет в сети интернет, для дистанционного управления справочником товаров.<br>Утилита “Редактор таблиц” для локального редактирования справочника товаров.<br>Питание USB, 5В, 1А от блока питания, АКБ типа 18650<br>Цвет Черный, красный<br>Температурный режим -10С - +45С<br>Личный кабинет https://lk.atol.ru/'
            });
            
            
            
            goods.push({
                name: "РИТЕЙЛ-КОМБО-01Ф без ФН",
                title: "РИТЕЙЛ-КОМБО-01Ф без ФН",
                group: "kkt-fr",
                imgSmall: "/img/1c/goods/kkt-fr/РИТЕЙЛ-КОМБО-01Ф без ФН-small.jpg",
                img: "/img/1c/goods/kkt-fr/РИТЕЙЛ-КОМБО-01Ф без ФН.jpg",
                price: "",
                text: '«Ритейл-Комбо-01Ф» – новый фискальный регистратор, выпущенный корейским производителем Sewoo в 2018 году. Устройство разработано на базе фирменного чекового принтера, что делает его интерфейс понятным и доступным. Модель отличается компактными размерами и дает возможность печатать чеки в двух положениях – горизонтальном и вертикальном.'
            });
            
            goods.push({
                name: "РИТЕЙЛ-01Ф без ФН",
                title: "РИТЕЙЛ-01Ф без ФН",
                group: "kkt-fr",
                imgSmall: "/img/1c/goods/kkt-fr/РИТЕЙЛ-01Ф без ФН-small.jpg",
                img: "/img/1c/goods/kkt-fr/РИТЕЙЛ-01Ф без ФН.jpg",
                price: "",
                text: 'базовая комплектация - 29000р<br>с 2LAN - 30000р<br><br>Ритейл 01Ф – это контрольно-кассовый регистратор, который записывает и хранит сведения в фискальных накопителях ФН-1. Устройство передает зашифрованные данные в органы налогообложения через ОФД, хранит информацию в электронном виде и печатает контрастные изображения на чеках в соответствии с законом № 54-ФЗ. Аппарат формирует 1D и 2D штрихкоды на термочувствительной бумажной ленте шириной 57 или 80 мм. Быстрая печать со скоростью 200 мм/c позволяет оперативно проводить операции по обслуживанию клиентов и применять фискальный аппарат Ритейл 01Ф в торговых точках, ресторанах, кафе, отелях, сфере услуг, автотранспорте и системе интернет-торговли.'
            });
            
            goods.push({
                name: "РИТЕЙЛ-02Ф без ФН",
                title: "РИТЕЙЛ-02Ф без ФН",
                group: "kkt-fr",
                imgSmall: "/img/1c/goods/kkt-fr/РИТЕЙЛ-02Ф без ФН-small.jpg",
                img: "/img/1c/goods/kkt-fr/РИТЕЙЛ-02Ф без ФН.jpg",
                price: "",
                text: 'Комплектации:<br>базовая (чёрный) - 15500р<br>с Wi-Fi (чёрный)- 16000р<br>с раз. ДЯ (чёрный) - 16000р<br>с Wi-Fi и раз. ДЯ (белый)- 16500р<br>с раз. ДЯ и автоотрезчиком (чёрный) - 19000р<br>с Wi-Fi, раз. ДЯ и автоотрезчиком (чёрный) - 19500р<br><br>Фискальный регистратор ШТРИХ-ФР-02Ф (РИТЕЙЛ-02Ф) – это новый онлайн фискальный регистратор с функцией передачи данных в налоговую через интернет. ШТРИХ-ФР-02Ф (РИТЕЙЛ-02Ф) является малогабаритным продолжением семейства контрольно-кассовых машин «РИТЕЙЛ» и сделан на базе нового принтера «Retail-02» (производство Корея). Фискальный регистратор работает на узкой чековой ленте – 57 мм и имеет ресурс термоголовки не менее 100 км.'
            });
            
            goods.push({
                name: "АТОЛ 22 v2Ф без ФН",
                title: "АТОЛ 22 v2Ф без ФН",
                group: "kkt-fr",
                imgSmall: "/img/1c/goods/kkt-fr/АТОЛ 22 v2Ф без ФН-small.jpg",
                img: "/img/1c/goods/kkt-fr/АТОЛ 22 v2Ф без ФН.jpg",
                price: "",
                text: 'АТОЛ 22 v2Ф - обновлённая версия популярного фискального регистратора АТОЛ FPrint-22ПТК, который был на рынке 10 лет. 22 v 2Ф - обновленная, усовершенствованная версия, спроектированная с учетом требований бизнеса и применением современных технологий.'
            });
            
            goods.push({
                name: "ШТРИХ LIGHT-01Ф без ФН",
                title: "ШТРИХ LIGHT-01Ф без ФН",
                group: "kkt-fr",
                imgSmall: "/img/1c/goods/kkt-fr/ШТРИХ LIGHT-01Ф без ФН-small.jpg",
                img: "/img/1c/goods/kkt-fr/ШТРИХ LIGHT-01Ф без ФН.jpg",
                price: "",
                text: 'Контрольно-кассовая техника «ШТРИХ-ЛАЙТ-01Ф» предназначена для применения организациями и индивидуальными предпринимателями при осуществлении ими расчетов. ККТ применяется только при наличии установленного внутри её корпуса фискального накопителя.<br><br>ККТ обеспечивает запись и хранение фискальных данных в фискальных накопителях, формирование фискальных документов, передачу фискальных документов в налоговые органы через оператора фискальных данных и печать фискальных документов на бумажных носителях в соответствии с правилами, установленными законодательством Российской Федерации о применении контрольно-кассовой техники (федеральный закон N 54-ФЗ от 22 мая 2003 года «о применении контрольно-кассовой техники при осуществлении наличных денежных расчетов и (или) расчетов с использованием электронных средств платежа.» и другие нормативные акты).'
            });
            
            goods.push({
                name: "АТОЛ 77Ф без ФН",
                title: "АТОЛ 77Ф без ФН",
                group: "kkt-fr",
                imgSmall: "/img/1c/goods/kkt-fr/АТОЛ 77Ф без ФН-small.jpg",
                img: "/img/1c/goods/kkt-fr/АТОЛ 77Ф без ФН.jpg",
                price: "",
                text: 'АТОЛ 77Ф – это контрольно-кассовая техника нового поколения. Устройство полностью соответствует новым требованиям 54-ФЗ (в ред. 290-ФЗ от 03.07.2016) и внесено в реестр ККТ на основании приказа Федеральной Налоговой Службы № ЕД-7-20/492@ от 15.09.2016 г.<br><br>Устройство позволяет осуществлять расчеты с покупателями на территории РФ в соответствии с действующим законодательством (ЕГАИС, 54-ФЗ новый порядок применения).'
            });
            
            goods.push({
                name: "АТОЛ 1Ф без ФН",
                title: "АТОЛ 1Ф без ФН",
                group: "kkt-fr",
                imgSmall: "/img/1c/goods/kkt-fr/АТОЛ 1Ф без ФН-small.jpg",
                img: "/img/1c/goods/kkt-fr/АТОЛ 1Ф без ФН.jpg",
                price: "",
                text: 'АТОЛ 1Ф - одна из самых доступных онлайн-касс во всей линейке оборудования марки АТОЛ. Это идеальное решение для представителей малого бизнеса, которые подыскивают экономичную ККТ с оптимальным набором функций.<br><br>Касса занимает минимум места в прикассовой зоне или на рабочем столе, имеет порт micro-USB для подключения к компьютеру (или другому управляющему устройству) и передачи данных в ОФД.'
            });
            
            goods.push({
                name: "АТОЛ 25Ф без ФН",
                title: "АТОЛ 25Ф без ФН",
                group: "kkt-fr",
                imgSmall: "/img/1c/goods/kkt-fr/АТОЛ 25Ф без ФН-small.jpg",
                img: "/img/1c/goods/kkt-fr/АТОЛ 25Ф без ФН.jpg",
                price: "",
                text: 'АТОЛ 25Ф — фискальный регистратор, работающий с широким чеком (80 мм) и рассчитанный на высокий поток клиентов. Онлайн-касса использует автоматический отрезчик чековой ленты японского производства. Надежный механизм защищает от заклинивания ножа.'
            });
            
            goods.push({
                name: "Касса №1 (\"К1-Ф\") без ФН",
                title: "Касса №1 (\"К1-Ф\") без ФН",
                group: "kkt-fr",
                imgSmall: "/img/1c/goods/kkt-fr/Касса №1 (К1-Ф) без ФН-small.jpg",
                img: "/img/1c/goods/kkt-fr/Касса №1 (К1-Ф) без ФН.jpg",
                price: "",
                text: 'К1-Ф — онлайн ККТ нового поколения, разработанная в соответствии с федеральным законом 54ФЗ. Касса способная передавать данные в ОФД и Налоговую инспекцию через соответствующие интерфейсы и обладает всеми необходимыми возможностями для полноценной работы. Возможность подключения сканера штрих кодов, денежного ящика и других устройств позволяет онлайн кассе К1 Ф составлять полноценную конкуренцию аналогам из данного ценового сегмента. Отличительными особенностями является простое управление кассовым устройством, достойная скорость печати чеков и наличие интерфейсов, которые позволяет подключать периферийные устройства, способные значительно расширить функционал применения ККТ для ведения бизнеса.'
            });
            
            goods.push({
                name: "ШТРИХ-СИТИ-Ф без ФН",
                title: "ШТРИХ-СИТИ-Ф без ФН",
                group: "kkt-fr",
                imgSmall: "/img/1c/goods/kkt-fr/ШТРИХ-СИТИ-Ф без ФН-small.jpg",
                img: "/img/1c/goods/kkt-fr/ШТРИХ-СИТИ-Ф без ФН.jpg",
                price: "",
                text: 'ШТРИХ-СИТИ-Ф — это фискальный регистратор со скоростью печати чека до 300 мм/с. Модель предназначается для торговых точек с большим количеством клиентов. Для дополнительного ускорения обслуживания покупателей установлен автоматический отрезчик гильотинного типа. Аппарат работает с чековой лентой шириной 58 или 80 мм. Замена рулона бумаги осуществляется по принципу «положил и печатай». Габаритные размеры 125 x 170 x 108 мм обеспечивают установку в условиях недостатка свободного пространства. Имеются порты USB, RS-232 и Ethernet.'
            });
            
            goods.push({
                name: "АТОЛ 27Ф без ФН",
                title: "АТОЛ 27Ф без ФН",
                group: "kkt-fr",
                imgSmall: "/img/1c/goods/kkt-fr/АТОЛ 27Ф без ФН-small.jpg",
                img: "/img/1c/goods/kkt-fr/АТОЛ 27Ф без ФН.jpg",
                price: "",
                text: 'Онлайн касса АТОЛ 27Ф – это самое технологичное решение в линейке АТОЛ для предприятий с высокой и средней пропускной способностью любых масштабов и сфер деятельности. Онлайн касса АТОЛ 27Ф включена в реестр онлайн ККТ приказом ФНС России от 19.02.2019 №ЕД-7-20/75@.<br><br>Заменить чековую ленту легко — одно нажатие кнопки и подпружиненная крышка откроется полностью, без риска травмы пальцев кассира. АТОЛ 27Ф удобен для кассовой зоны самообслуживания за счет рулонной подачи чековой ленты.<br>Три разноцветных индикатора помогут кассиру ориентироваться в показаниях кассы.<br>За метр до окончания чековой ленты зажигается отдельный световой индикатор.<br>Кнопка включения расположена на задней панели кассы для предупреждения случайных нажатий.<br><br>Прочный металлический каркас.<br>Для защиты от налипания пыли и мелкого мусора в пластик корпуса добавлен антистатик.<br>Разъем питания с дополнительной фиксацией предохранит от случайного выдергивания. Кабели зафиксированы пластиковым зажимом.<br>АТОЛ 27Ф - это онлайн-касса с высоким ресурсом печатающего механизма и автоотреза.'
            });
            
            goods.push({
                name: "АТОЛ 55Ф без ФН",
                title: "АТОЛ 55Ф без ФН",
                group: "kkt-fr",
                imgSmall: "/img/1c/goods/kkt-fr/АТОЛ 55Ф без ФН-small.jpg",
                img: "/img/1c/goods/kkt-fr/АТОЛ 55Ф без ФН.jpg",
                price: "",
                text: 'Рекомендации по сфере применения: Решение для предприятий со средней пропускной способностью любых масштабов и сфер деятельности с предоставлением узкого чека.<br>Скорость печати: до 200 мм/с<br>Ресурс печатной головки: 100 км<br>Автоотрез чека: Да, до 1 000 000 отрезов<br>Длина намотки чековой ленты: 80 м<br>Диаметр рулона чековой ленты: 83 мм<br>Ширина чека: 58/44 мм<br>Передача данных: USB, Ethernet<br>Беспроводная передача данных: 2G/3G, Bluetooth или Wi-Fi (через дополнительный модуль)<br>Подключение к денежному ящику: RJ 45<br>Подключение к дисплею покупателя: RS 232C<br>Подключение к питанию: 24В от блока питания<br>Размеры ДЛхШРхВС: 200х120х135 мм<br>Вес без чековой ленты: 1,2 кг'
            });
            
            goods.push({
                name: "АТОЛ 11Ф Мобильный",
                title: "АТОЛ 11Ф Мобильный",
                group: "kkt-fr",
                imgSmall: "/img/1c/goods/kkt-fr/АТОЛ 11Ф Мобильный-small.jpg",
                img: "/img/1c/goods/kkt-fr/АТОЛ 11Ф Мобильный.jpg",
                price: "",
                text: 'Рекомендации по сфере применения: Решение для предприятий любых сфер деятельности, осуществляющих мобильную торговлю или доставку товаров, оказывающих выездные услуги.<br>Скорость печати: до 75 мм/с<br>Ресурс печатной головки: 50 км<br>Автоотрез чека: Нет, гребенка<br>Длина намотки чековой ленты: 35 м<br>Диаметр рулона чековой ленты: 47 мм<br>Ширина чека: 58/44 мм<br>Передача данных: USB<br>Беспроводная передача данных: 2G/3G, Bluetooth или Wi-Fi (через дополнительный модуль)<br>Подключение к денежному ящику: RJ 45<br>Подключение к дисплею покупателя: RS 232<br>Подключение к питанию АКБ: типа 18650, 1600mAh*2, от блока питания 24В<br>Время работы от аккумклятора: до 15 часов<br>Размеры ДЛхШРхВС: 160х88х79 мм<br>Вес без чековой ленты: 0,36 кг'
            });
            
            goods.push({
                name: "АТОЛ 50Ф без ФН",
                title: "АТОЛ 50Ф без ФН",
                group: "kkt-fr",
                imgSmall: "/img/1c/goods/kkt-fr/АТОЛ 50Ф без ФН-small.jpg",
                img: "/img/1c/goods/kkt-fr/АТОЛ 50Ф без ФН.jpg",
                price: "",
                text: 'Рекомендации по сфере применения: Универсальное решение, рассчитанное на средний поток покупателей, с предоставлением узкого чека.<br>Скорость печати: до 100 мм/с<br>Ресурс печатной головки: 50 км<br>Автоотрез чека: Да, до 500 000 отрезов<br>Длина намотки чековой ленты: 80 м<br>Диаметр рулона чековой ленты: 80 мм<br>Ширина чека: 58/44 мм<br>Передача данных: USB<br>Беспроводная передача данных: 2G/3G, Bluetooth или Wi-Fi (через дополнительный модуль)<br>Подключение к денежному ящику: RJ 45<br>Подключение к дисплею покупателя: —<br>Подключение к питанию: 9В от блока питания<br>Размеры ДЛхШРхВС: 200х115х135 мм<br>Вес без чековой ленты: 0,9 кг'
            });
            
            goods.push({
                name: "ШТРИХ-МИНИ-02Ф без ФН",
                title: "ШТРИХ-МИНИ-02Ф без ФН",
                group: "kkt-fr",
                imgSmall: "/img/1c/goods/kkt-fr/ШТРИХ-МИНИ-02Ф без ФН-small.jpg",
                img: "/img/1c/goods/kkt-fr/ШТРИХ-МИНИ-02Ф без ФН.jpg",
                price: "",
                text: 'Технические характеристики<br>Рекомендовано для работы с ЕГАИС: Да<br>Тип устройства: ККМ<br>Работа с одномерными (1D) штрих-кодами: EAN-13<br>Работа с двумерными (2D) штрих-кодами: QR Code<br>Макс. ширина бумаги, мм: 80<br>Скорость печати, мм/сек: 300<br>Интерфейс: RS-232, RJ-11, USB - 1 шт<br>Температура работы мин., °C: +10<br>Температура работы макс., °C: +40<br>Габариты оборудования (ШхГхВ), мм: 147х207х14<br>Вес нетто, кг: 2<br>Цвет корпуса: Белый, Черный<br>Драйвера: Windows Driver, OPOS, JavaPOS'
            });
            
            goods.push({
                name: "ШТРИХ-ЛАЙТ-01Ф без ФН",
                title: "ШТРИХ-ЛАЙТ-01Ф без ФН",
                group: "kkt-fr",
                imgSmall: "/img/1c/goods/kkt-fr/ШТРИХ-ЛАЙТ-01Ф без ФН-small.jpg",
                img: "/img/1c/goods/kkt-fr/ШТРИХ-ЛАЙТ-01Ф без ФН.jpg",
                price: "",
                text: 'Характеристики печатающего устройства:<br>Метод печати – прямая термопечать;<br>Скорость печати, мм/сек – 200;<br>Область печати, мм (точек) - 47 (576);<br>Количество колонок (при печати стандартным шрифтом), шт. – 32;<br>Бумага:<br>тип бумаги – термобумага (обеспечивающая сохранность напечатанных на ней данных не менее 6 мес. со дня печати);<br>размеры ленты, мм:<br>ширина – 57,5±0,5;<br>толщина ленты, мкм – 60-120;<br>наружный диаметр рулона, не более – 60;<br>Наличие отрезчика – да.<br>Количество секций – 16.<br>Количество кассиров – 30.<br>Разрядность денежных регистров – 12.<br>Разрядность операционных регистров – 4 (после номера чека или отчета 9999 идет номер 0000).<br>Количество налоговых ставок – 4.<br>Масса, кг, не более – 3,2.<br>Габариты, мм – 118х205х110 (ШxГxВ).<br><br>Технические характеристики<br>Фильтр для онлайн-касс<br>Подходит для работы в системе ЕГАИС, Узкая лента 57 мм, Автоотрезчик, Все сферы применения, Высокая скорость печати, RS-232, USB, Wi-Fi<br>Кому подходит<br>Торговля любыми товарами* Ресторан (любой формат)* Услуги *100 и более чеков в день'
            });
            
            goods.push({
                name: "ЭЛВЕС-ФР-Ф без ФН",
                title: "ЭЛВЕС-ФР-Ф без ФН",
                group: "kkt-fr",
                imgSmall: "/img/1c/goods/kkt-fr/ЭЛВЕС-ФР-Ф без ФН-small.jpg",
                img: "/img/1c/goods/kkt-fr/ЭЛВЕС-ФР-Ф без ФН.jpg",
                price: "",
                text: 'Технические характеристики<br>Фильтр для онлайн-касс Подходит для работы в системе ЕГАИС, Широкая лента 80 мм, Автоотрезчик, Высокая скорость печати, RS-232, Ethernet (LAN), USB, Wi-Fi<br>Кому подходит -Торговля любыми товарами -Услуги -Кафе, fast-food -Бары и рестораны<br>Совместимо с -Денежный ящик ШТРИХ/EPSON -Интеграция с 1С<br>Метод печати прямая термопечать<br>Скорость печати, мм/сек 220<br>Область печати, мм (точек) 72 (576)<br>Количество колонок (при печати стандартным шрифтом), шт 48<br>Тип бумаги термобумага<br>Ширина ленты, мм 80<br>Толщина ленты, мкм 60-90<br>Наружный диаметр рулона не более 80<br>Количество секций 16<br>Количество кассиров 30<br>Разрядность денежных регистров 12<br>Разрядность операционных регистров 4<br>Количество налоговых ставок 6<br>Электропитание ККТ через сетевой адаптер от сети переменного тока частотой 50-60Гц, напряжением 220-240В<br>Максимальная потребляемая мощность ККТ, Вт не более 60<br>Выходные параметры сетевого адаптера 24 В, 2,5 А<br>Масса, кг не более 1.3<br>Габариты, мм 145х195х148 (ШхГхВ)<br>Системные требования к ПК для работы с ККТ<br>операционная система не ниже Windows 7, три порта USB, один порт Ethernet (опционально), один COM-порт<br>Интерфейсы USB, COM, Ethernet, Wi-Fi (интегрированный)<br>Автоотрезчик гильотинный 2 000 000 операций<br>Работа с денежным ящиком ШТРИХ,EPSON'
            });
            
            goods.push({
                name: "ШТРИХ-НАНО-Ф без ФН",
                title: "ШТРИХ-НАНО-Ф без ФН",
                group: "kkt-fr",
                imgSmall: "/img/1c/goods/kkt-fr/ШТРИХ-НАНО-Ф без ФН-small.jpg",
                img: "/img/1c/goods/kkt-fr/ШТРИХ-НАНО-Ф без ФН.jpg",
                price: "",
                text: 'Мобильная онлайн-касса. Самая бюджетная онлайн-касса на рынке. Компактная, легкая и эргономичная. Помещается на ладони. Работает от аккумулятора.<br><br>Применение<br><br>Розничные магазины (организация дополнительных кассовых мест, сокращение очередей)<br>Мобильная торговля (курьерская служба, доставка из интернет- магазинов, высокая автономность – до 14 часов работы от аккумулятора)<br>Услуги (Совместимость: единый протокол работы ШТРИХ-М)<br>Продажа билетов (Лотереи, выставки, промо-акции: работа с мобильными платформами Android, Linux)<br>Технические характеристики<br><br>Тип устройства ККМ<br>Метод печати прямая термопечать<br>Скорость печати, мм/сек 60<br>Область печати, мм (точек) 48 (384) - для бумаги шириной 57 мм;<br>40 (320) - для бумаги шириной 44 мм (опционально);<br>Количество колонок (при печати стандартным шрифтом), шт 32- для бумаги шириной 57 мм;<br>32- для бумаги шириной 44 мм (опционально);<br>Тип бумаги термобумага<br>Размеры ленты, ширина, мм – 57±0,5, 44±0,5(опционально);<br>толщина ленты, мкм – 60-100<br>наружный диаметр рулона, мм – не более 40;<br>Интерфейсы Bluetooth; WiFi<br>Электропитание ККТ Питание ККТ осуществляется от литиевой батареи, 2600mАч, 3,7 В;<br>Подзарядка батареи производится от: Сетевой адаптер (Вход 100-240В 50Гц; Выход: номинальное напряжение 5В и 1A постоянного тока) и микро USB разъем;<br>ПК и микро USB разъем.<br>Максимальная потребляемая мощность адаптера, Вт не более 5.<br>Масса, кг более 0.25.<br>Габариты, мм 114х82х57 (ШxГxВ).<br>Технические характеристики<br>Фильтр для онлайн-касс<br>Автономная работа от встроенного аккумулятора, Подходит для работы в системе ЕГАИС, Узкая лента 57 мм, Компактные габариты, Wi-Fi, Bluetooth<br>Кому подходит<br>Торговля любыми товарами Мобильная торговля Курьерская служба Такси<br>Совместимо с<br>Планшеты/смартфоны на Android'
            });
            
            goods.push({
                name: "Атол FPrint-22ПТК без ФН",
                title: "Атол FPrint-22ПТК без ФН",
                group: "kkt-fr",
                imgSmall: "/img/1c/goods/kkt-fr/Атол FPrint-22ПТК без ФН-small.jpg",
                img: "/img/1c/goods/kkt-fr/Атол FPrint-22ПТК без ФН.jpg",
                price: "",
                text: 'Рекомендации по сферам применения Решение для предприятий со средней пропускной способностью любых масштабов и сфер деятельности с предоставлением широкого чека<br>Способ печати Термопечать<br>Качество печати, dpi 203<br>Способ загрузки бумаги Easy Load<br>Автоотрез Да<br>Ресурс автоотреза, операций 1 000 000<br>Ширина чека 80/58<br>Скорость печати, мм/секунду до 200<br>Ресурс печатающей головки, км чековой ленты 100<br>Количество символов в строке от 24 до 64 (при бумаге 80 мм), от 24 до 48 (при бумаге 58 мм)<br>Диаметр рулона, мм 83<br>Подключение денежного ящика 24V Да<br>Подключение дисплея покупателя Да<br>Интерфейс подключения Ethernet, USB, RS-232C<br>Габариты, мм 131х135х195<br>Вес, кг 1.4<br>Совместимость с ПО «АТОЛ: Драйвер ККТ» для простоты подключения к кассовому программному обеспечению. Совместимо с 1С<br>Цвет Белый, черный<br>Условия эксплуатации Температура +5…+45 °С, влажность не выше 85% при +35 °С'
            });
            
            goods.push({
                name: "Атол 11Ф без ФН",
                title: "Атол 11Ф без ФН",
                group: "kkt-fr",
                imgSmall: "/img/1c/goods/kkt-fr/Атол 11Ф без ФН-small.jpg",
                img: "/img/1c/goods/kkt-fr/Атол 11Ф без ФН.jpg",
                price: "",
                text: 'Способ печати Термопечать<br>Качество печати, dpi 203<br>Автоотрез Нет, Металлическая гребенка<br>Ширина чека 44/58 мм<br>Скорость печати мм/с до 75<br>Количество символов в строке от 24 до 42 (при бумаге 58 мм)<br>от 24 до 34 (при бумаге 44 мм)<br>Диаметр рулона, мм 47<br>Подключение денежного ящика Да, 24V<br>Подключение к ПК RS, USB, Wi-Fi, Bluetooth (опционально)<br>Передача данных в ОФД USB, 2G/3G, BT или Wi-Fi (опционально)<br>Питание 24В от блока питания<br>Wi-Fi Опция<br>Ethernet Есть<br>Bluetooth Опция<br>Габариты, мм 88х160х79<br>Вес нетто, кг 0,36<br>Совместимость с ОП Windows, Linux, Android или iOS<br>Цвет Белый / черный<br>Ресург ПГ, км (заявленный) 50<br>Программное обеспечение Совместимо с 1С. Перечень совместимого ПО на сайте: www.atol.ru/softdev/'
            });
            
            goods.push({
                name: "АТОЛ 30Ф без ФН",
                title: "АТОЛ 30Ф без ФН",
                group: "kkt-fr",
                imgSmall: "/img/1c/goods/kkt-fr/АТОЛ 30Ф без ФН-small.jpg",
                img: "/img/1c/goods/kkt-fr/АТОЛ 30Ф без ФН.jpg",
                price: "",
                text: 'Способ печати Термопечать<br>Качество печати, dpi 203<br>Автоотрез Нет, Металлическая гребенка<br>Ширина чека 44/58 мм<br>Скорость печати мм/с до 75<br>Количество символов в строке от 24 до 42 (при бумаге 58 мм)<br>от 24 до 34 (при бумаге 44 мм)<br>Диаметр рулона, мм 47<br>Подключение денежного ящика Нет<br>В версии АТОЛ 30Ф+<br>Подключение к ПК USB, Wi-Fi, Bluetooth (опционально)<br>Передача данных в ОФД USB, 2G/3G, BT или Wi-Fi (опционально)<br>Питание 98В от блока питания<br>Wi-Fi Опция<br>Ethernet Да<br>Bluetooth Опция<br>Габариты, мм 88х160х79<br>Вес нетто, кг 0,36<br>Совместимость с ОП Windows, Linux, Android или iOS<br>Цвет Темно-серый<br>Ресург ПГ, км (заявленный) 50<br>Программное обеспечение Совместимо с 1С. Перечень совместимого ПО на сайте: www.atol.ru/softdev/'
            });
            
            goods.push({
                name: "АТОЛ 20Ф без ФН",
                title: "АТОЛ 20Ф без ФН",
                group: "kkt-fr",
                imgSmall: "/img/1c/goods/kkt-fr/АТОЛ 20Ф без ФН-small.jpg",
                img: "/img/1c/goods/kkt-fr/АТОЛ 20Ф без ФН.jpg",
                price: "",
                text: 'Способ печати Термопечать<br>Качество печати, dpi 203<br>Автоотрез Да, ресурс 500 000 отрезов<br>Ширина чека 44/58/80 мм<br>Скорость печати мм/с до 100<br>Количество символов в строке от 48 до 64 (при бумаге 80 мм)<br>от 32 до 48 (при бумаге 58 мм)<br>от 24 до 27 (при бумаге 44 мм)<br>Диаметр рулона, мм 83<br>Подключение денежного ящика Да, 24V<br>Подключение к ПК USB, Wi-Fi, Bluetooth (опционально)<br>Передача данных в ОФД USB, 2G/3G, BT или Wi-Fi (опционально)<br>Питание 24В от блока питания<br>Wi-Fi Опция<br>Ethernet Нет<br>Bluetooth Опция<br>Габариты, мм 131х135х195<br>Вес нетто, кг 1,1<br>Совместимость с ОП Windows, Linux, Android или iOS<br>Цвет Темно-серый<br>Ресург ПГ, км (заявленный) 50<br>Программное обеспечение Совместимо с 1С. Перечень совместимого ПО на сайте: www.atol.ru/softdev/'
            });
            
            goods.push({
                name: "Штрих-ON-LINE без ФН",
                title: "Штрих-ON-LINE без ФН",
                group: "kkt-fr",
                imgSmall: "/img/1c/goods/kkt-fr/Штрих-ON-LINE без ФН-small.jpg",
                img: "/img/1c/goods/kkt-fr/Штрих-ON-LINE без ФН.jpg",
                price: "",
                text: 'Технические характеристики<br>Рекомендовано для работы с ЕГАИС Да<br>Фильтр для онлайн-касс Подходит для работы в системе ЕГАИС, Узкая лента 57 мм, Все сферы применения, Компактные габариты, RS-232, USB, Wi-Fi<br>Кому подходит Торговля любыми товарами* Fast-food (кафе-столовая)* Услуги *70-100 чеков в день<br>Совместимо с ПО «ПЛЮС Кассир» Бюджетная автоматизация Денежный ящик «ШТРИХ-М» Весы, банковское и периферийное оборудование «ШТРИХ-М» (через ПК)<br><br>Тип устройства ККМ<br>Макс. ширина бумаги, мм 57<br>Внешний диаметр рулона бумаги, мм не более 60<br>Скорость печати, мм/сек 75<br>Интерфейс RS-232, USB - 1 шт<br>Потребляемая мощность, Вт не более 35<br>Диапазон рабочих температур, °C +10°C..+40°C<br>Габариты оборудования (ШхГхВ), мм 107х162х100<br>Вес нетто, кг 0,7<br>Драйвера Windows Driver, OPOS, JavaPOS<br>Гарантия 12 месяцев<br>Страна производства Россия<br>Автоотрезчик Нет'
            });
            
            goods.push({
                name: "Штрих-М-01Ф без ФН",
                title: "Штрих-М-01Ф без ФН",
                group: "kkt-fr",
                imgSmall: "/img/1c/goods/kkt-fr/Штрих-М-01Ф без ФН-small.jpg",
                img: "/img/1c/goods/kkt-fr/Штрих-М-01Ф без ФН.jpg",
                price: "",
                text: 'Характеристики печатающего устройства:<br>Метод печати – прямая термопечать;<br>Скорость печати, мм/сек – 200;<br>Область печати, мм (точек) - 72 (576);<br>Количество колонок (при печати стандартным шрифтом), шт – 48;<br>Бумага: тип бумаги – термобумага;<br>размеры ленты, мм: ширина – 80±1;<br>толщина ленты, мкм – 60-120;<br>наружный диаметр рулона, не более – 83;<br>Наличие отрезчика – да.<br>Количество секций – 16.<br>Количество кассиров – 30.<br>Разрядность денежных регистров – 12.<br>Разрядность операционных регистров – 4 (после номера чека или отчета 9999 идет номер 0000).<br>Количество налоговых ставок – 4.<br>Масса, кг, не более – 3,4.<br>Габариты, мм – 150х225х130(ШxГxВ).<br><br>Технические характеристики<br>Фильтр для онлайн-касс<br>Подходит для работы в системе ЕГАИС, Широкая лента 80 мм, Автоотрезчик, Высокая скорость печати, RS-232, Ethernet (LAN), USB, Wi-Fi<br>Кому подходит<br>Торговля любыми товарами* Ресторан (любой формат)* Услуги *100 и более чеков в день<br>Совместимо с<br>ПО «ПЛЮС Кассир» Бюджетная автоматизация Денежный ящик «ШТРИХ-М» Весы, банковское и периферийное оборудование «ШТРИХ-М» (через ПК)'
            });
            
            
            
            goods.push({
                name: "Фискальный накопитель на 36 мес.",
                title: "Фискальный накопитель на 36 мес.",
                group: "kkt-fn",
                imgSmall: "/img/1c/goods/kkt-fn/Фискальный накопитель на 36 мес.-small.jpg",
                img: "/img/1c/goods/kkt-fn/Фискальный накопитель на 36 мес..jpg",
                price: "21 500",
                text: 'Фискальный накопитель'
            });
            
            goods.push({
                name: "Фискальный накопитель на 15 мес.",
                title: "Фискальный накопитель на 15 мес.",
                group: "kkt-fn",
                imgSmall: "/img/1c/goods/kkt-fn/Фискальный накопитель на 15 мес.-small.jpg",
                img: "/img/1c/goods/kkt-fn/Фискальный накопитель на 15 мес..jpg",
                price: "14 500",
                text: 'Фискальный накопитель'
            });
            
            
            
            
            goods.push({
                name: "Услуги по замене ФН",
                title: "Услуги по замене ФН",
                group: "kkt-services",
                imgSmall: "/img/1c/goods/kkt-services/Услуги по замене ФН-small.jpg",
                img: "/img/1c/goods/kkt-services/Услуги по замене ФН.jpg",
                price: "2 500",
                text: 'Услуги по замене ФН'
            });
            
            goods.push({
                name: "Услуги по регистрации (перерегистрации) ККТ в ФНС",
                title: "Услуги по регистрации (перерегистрации) ККТ в ФНС",
                group: "kkt-services",
                imgSmall: "/img/1c/goods/kkt-services/Услуги по регистрации (перерегистрации) ККТ в ФНС-small.jpg",
                img: "/img/1c/goods/kkt-services/Услуги по регистрации (перерегистрации) ККТ в ФНС.jpg",
                price: "2 000",
                text: 'Услуги по регистрации (перерегистрации) ККТ в ФНС'
            });
            
            goods.push({
                name: "Услуги по смене режима налогообложения на автономных сенсорных кассах",
                title: "Услуги по смене режима налогообложения на автономных сенсорных кассах",
                group: "kkt-services",
                imgSmall: "/img/1c/goods/kkt-services/Услуги по смене режима налогообложения на автономных сенсорных кассах-small.jpg",
                img: "/img/1c/goods/kkt-services/Услуги по смене режима налогообложения на автономных сенсорных кассах.jpg",
                price: "1 500",
                text: 'Услуги по смене режима налогообложения на автономных сенсорных кассах (Нева, Эвотор, МТС, Кассатка)'
            });
            
            goods.push({
                name: "Услуги по смене режима налообложения на фискальных регистраторах",
                title: "Услуги по смене режима налообложения на фискальных регистраторах",
                group: "kkt-services",
                imgSmall: "/img/1c/goods/kkt-services/Услуги по смене режима налообложения на фискальных регистраторах-small.jpg",
                img: "/img/1c/goods/kkt-services/Услуги по смене режима налообложения на фискальных регистраторах.jpg",
                price: "1 500",
                text: 'Услуги по смене режима налообложения на фискальных регистраторах (Атолл, Штрих и пр)'
            });
            
            goods.push({
                name: "Услуги по смене режима налогообложения на автономных кнопочных ККТ",
                title: "Услуги по смене режима налогообложения на автономных кнопочных ККТ",
                group: "kkt-services",
                imgSmall: "/img/1c/goods/kkt-services/Услуги по смене режима налогообложения на автономных кнопочных ККТ-small.jpg",
                img: "/img/1c/goods/kkt-services/Услуги по смене режима налогообложения на автономных кнопочных ККТ.jpg",
                price: "2 500",
                text: 'Услуги по смене режима налогообложения на автономных кнопочных ККТ (Меркурий. Элвес и пр)'
            });
            
            goods.push({
                name: "Ремонт и прочие услуги",
                title: "Ремонт и прочие услуги",
                group: "kkt-services",
                imgSmall: "/img/1c/goods/kkt-services/Ремонт и прочие услуги-small.jpg",
                img: "/img/1c/goods/kkt-services/Ремонт и прочие услуги.jpg",
                price: "по факту выполненных работ",
                text: 'Цена назначается согласно сложности и длительности услуги'
            });
            
            goods.push({
                name: "Услуги по перепрошивке ККТ",
                title: "Услуги по перепрошивке ККТ",
                group: "kkt-services",
                imgSmall: "/img/1c/goods/kkt-services/Услуги по перепрошивке ККТ-small.jpg",
                img: "/img/1c/goods/kkt-services/Услуги по перепрошивке ККТ.jpg",
                price: "2 000",
                text: 'Услуги по перепрошивке ККТ'
            });
            
            goods.push({
                name: "Выезд специалиста в рамках разовых работ",
                title: "Выезд специалиста в рамках разовых работ",
                group: "kkt-services",
                imgSmall: "/img/1c/goods/kkt-services/Выезд специалиста в рамках разовых работ-small.jpg",
                img: "/img/1c/goods/kkt-services/Выезд специалиста в рамках разовых работ.jpg",
                price: "от 1 500",
                text: 'Выезд специалиста в рамках разовых работ'
            });
            
            goods.push({
                name: "Обслуживание ККТ в месяц (по желанию заказчика)",
                title: "Обслуживание ККТ в месяц (по желанию заказчика)",
                group: "kkt-services",
                imgSmall: "/img/1c/goods/kkt-services/Обслуживание ККТ в месяц (по желанию заказчика)-small.jpg",
                img: "/img/1c/goods/kkt-services/Обслуживание ККТ в месяц (по желанию заказчика).jpg",
                price: "3 000",
                text: 'Обслуживание ККТ в месяц (по желанию заказчика)'
            });
            
            
            
            
            goods.push({
                name: "Чековая лента, термо, 57ммх10х12, намотка 17м",
                title: "Чековая лента, термо, 57ммх10х12, намотка 17м",
                group: "kkt-rash-mat",
                imgSmall: "/img/1c/goods/kkt-rash-mat/Чековая лента, термо, 57ммх10х12, намотка 10м-small.jpg",
                img: "/img/1c/goods/kkt-rash-mat/Чековая лента, термо, 57ммх10х12, намотка 10м.jpg",
                price: "32",
                text: 'Чековая лента, термо, 57ммх10х12, намотка 17м'
            });
            
            goods.push({
                name: "Чековая лента, термо, 57ммх40х12, намотка 29м",
                title: "Чековая лента, термо, 57ммх40х12, намотка 29м",
                group: "kkt-rash-mat",
                imgSmall: "/img/1c/goods/kkt-rash-mat/Чековая лента, термо, 57ммх40х12, намотка 29м-small.jpg",
                img: "/img/1c/goods/kkt-rash-mat/Чековая лента, термо, 57ммх40х12, намотка 29м.jpg",
                price: "54",
                text: 'Чековая лента, термо, 57ммх40х12, намотка 29м'
            });
            
            goods.push({
                name: "Чековая лента, термо, 80ммх80х12, намотка 63м",
                title: "Чековая лента, термо, 80ммх80х12, намотка 63м",
                group: "kkt-rash-mat",
                imgSmall: "/img/1c/goods/kkt-rash-mat/Чековая лента, термо, 80ммх80х12, намотка 53м-small.jpg",
                img: "/img/1c/goods/kkt-rash-mat/Чековая лента, термо, 80ммх80х12, намотка 53м.jpg",
                price: "150",
                text: 'Чековая лента, термо, 80ммх80х12, намотка 63м'
            });
            
            
            
            goods.push({
                name: "Устройство модернизации с Wi-Fi + Ethernet (без ФН)",
                title: "Устройство модернизации с Wi-Fi + Ethernet (без ФН)",
                group: "kkt-modern",
                imgSmall: "/img/1c/goods/kkt-modern/Устройство модернизации с Wi-Fi + Ethernet (без ФН)-small.jpg",
                img: "/img/1c/goods/kkt-modern/Устройство модернизации с Wi-Fi + Ethernet (без ФН).jpg",
                price: "",
                text: 'Устройство модернизации с Wi-Fi + Ethernet (без ФН)'
            });
            
            goods.push({
                name: "Устройство модернизации с Ethernet (без ФН) ШТРИХ",
                title: "Устройство модернизации с Ethernet (без ФН) ШТРИХ",
                group: "kkt-modern",
                imgSmall: "/img/1c/goods/kkt-modern/Устройство модернизации с Ethernet (без ФН) ШТРИХ-small.jpg",
                img: "/img/1c/goods/kkt-modern/Устройство модернизации с Ethernet (без ФН) ШТРИХ.jpg",
                price: "",
                text: 'Устройство модернизации с Ethernet (без ФН) ШТРИХ'
            });
            
            goods.push({
                name: "Комплект активации №4 ШТРИХ-ФР-01Ф",
                title: "Комплект активации №4 ШТРИХ-ФР-01Ф",
                group: "kkt-modern",
                imgSmall: "/img/1c/goods/kkt-modern/Комплект активации №4 ШТРИХ-ФР-01Ф-small.jpg",
                img: "/img/1c/goods/kkt-modern/Комплект активации №4 ШТРИХ-ФР-01Ф.jpg",
                price: "",
                text: 'Комплект активации №4 "ШТРИХ-ФР-01Ф"'
            });
            
            goods.push({
                name: "Комплект активации №3 ШТРИХ-МИНИ-01Ф",
                title: "Комплект активации №3 ШТРИХ-МИНИ-01Ф",
                group: "kkt-modern",
                imgSmall: "/img/1c/goods/kkt-modern/Комплект активации №3 ШТРИХ-МИНИ-01Ф-small.jpg",
                img: "/img/1c/goods/kkt-modern/Комплект активации №3 ШТРИХ-МИНИ-01Ф.jpg",
                price: "",
                text: 'Комплект активации №3 "ШТРИХ-МИНИ-01Ф"'
            });
            
            goods.push({
                name: "Комплект активации №8 ШТРИХ-ЛАЙТ-02Ф (Ethernet+USB)",
                title: "Комплект активации №8 ШТРИХ-ЛАЙТ-02Ф (Ethernet+USB)",
                group: "kkt-modern",
                imgSmall: "/img/1c/goods/kkt-modern/Комплект активации №8 ШТРИХ-ЛАЙТ-02Ф (Ethernet+USB)-small.jpg",
                img: "/img/1c/goods/kkt-modern/Комплект активации №8 ШТРИХ-ЛАЙТ-02Ф (Ethernet+USB).jpg",
                price: "",
                text: 'Комплект активации №8 "ШТРИХ-ЛАЙТ-02Ф" (Ethernet+USB)'
            });
            
            goods.push({
                name: "АТОЛ Комплект модернизации FPrint-11ПТК до АТОЛ 11Ф (Программно-аппаратная модернизация)",
                title: "АТОЛ Комплект модернизации FPrint-11ПТК до АТОЛ 11Ф (Программно-аппаратная модернизация)",
                group: "kkt-modern",
                imgSmall: "/img/1c/goods/kkt-modern/АТОЛ Комплект модернизации FPrint-11ПТК до АТОЛ 11Ф (Программно-аппаратная модернизация)-small.jpg",
                img: "/img/1c/goods/kkt-modern/АТОЛ Комплект модернизации FPrint-11ПТК до АТОЛ 11Ф (Программно-аппаратная модернизация).jpg",
                price: "",
                text: 'АТОЛ Комплект модернизации FPrint-11ПТК до АТОЛ 11Ф (Программно-аппаратная модернизация)'
            });
            
            goods.push({
                name: "АТОЛ Комплект модернизации FPrint-22К/ПТК до АТОЛ FPrint-22ПТК (Программно-аппаратная модернизация)",
                title: "АТОЛ Комплект модернизации FPrint-22К/ПТК до АТОЛ FPrint-22ПТК (Программно-аппаратная модернизация)",
                group: "kkt-modern",
                imgSmall: "/img/1c/goods/kkt-modern/АТОЛ Комплект модернизации FPrint-22К_ПТК до АТОЛ FPrint-22ПТК (Программно-аппаратная модернизация)-small.jpg",
                img: "/img/1c/goods/kkt-modern/АТОЛ Комплект модернизации FPrint-22К_ПТК до АТОЛ FPrint-22ПТК (Программно-аппаратная модернизация).jpg",
                price: "",
                text: 'АТОЛ Комплект модернизации FPrint-22К/ПТК до АТОЛ FPrint-22ПТК (Программно-аппаратная модернизация)'
            });
            
            goods.push({
                name: "АТОЛ Комплект модернизации FPrint-22 до АТОЛ FPrint-22ПТК",
                title: "АТОЛ Комплект модернизации FPrint-22 до АТОЛ FPrint-22ПТК",
                group: "kkt-modern",
                imgSmall: "/img/1c/goods/kkt-modern/АТОЛ Комплект модернизации FPrint-22 до АТОЛ FPrint-22ПТК-small.jpg",
                img: "/img/1c/goods/kkt-modern/АТОЛ Комплект модернизации FPrint-22 до АТОЛ FPrint-22ПТК.jpg",
                price: "",
                text: 'АТОЛ Комплект модернизации FPrint-22 до АТОЛ FPrint-22ПТК'
            });
            
            goods.push({
                name: "АТОЛ Комплект модернизации FPrint-11 до АТОЛ 11Ф",
                title: "АТОЛ Комплект модернизации FPrint-11 до АТОЛ 11Ф",
                group: "kkt-modern",
                imgSmall: "/img/1c/goods/kkt-modern/АТОЛ Комплект модернизации FPrint-11 до АТОЛ 11Ф-small.jpg",
                img: "/img/1c/goods/kkt-modern/АТОЛ Комплект модернизации FPrint-11 до АТОЛ 11Ф.jpg",
                price: "",
                text: 'АТОЛ Комплект модернизации FPrint-11 до АТОЛ 11Ф'
            });
            
            goods.push({
                name: "АТОЛ Коммуникационный модуль (WiFi, 2G, Bluetooth)",
                title: "АТОЛ Коммуникационный модуль (WiFi, 2G, Bluetooth)",
                group: "kkt-modern",
                imgSmall: "/img/1c/goods/kkt-modern/АТОЛ Коммуникационный модуль (WiFi, 2G, Bluetooth)-small.jpg",
                img: "/img/1c/goods/kkt-modern/АТОЛ Коммуникационный модуль (WiFi, 2G, Bluetooth).jpg",
                price: "",
                text: 'АТОЛ Коммуникационный модуль (WiFi, 2G, Bluetooth)'
            });
            
            goods.push({
                name: "АТОЛ Коммуникационный модуль (2G, Bluetooth)",
                title: "АТОЛ Коммуникационный модуль (2G, Bluetooth)",
                group: "kkt-modern",
                imgSmall: "/img/1c/goods/kkt-modern/АТОЛ Коммуникационный модуль (2G, Bluetooth)-small.jpg",
                img: "/img/1c/goods/kkt-modern/АТОЛ Коммуникационный модуль (2G, Bluetooth).jpg",
                price: "",
                text: 'АТОЛ Коммуникационный модуль (2G, Bluetooth)'
            });
            
            goods.push({
                name: "АТОЛ Коммуникационный модуль (WiFi)",
                title: "АТОЛ Коммуникационный модуль (WiFi)",
                group: "kkt-modern",
                imgSmall: "/img/1c/goods/kkt-modern/АТОЛ Коммуникационный модуль (WiFi)-small.jpg",
                img: "/img/1c/goods/kkt-modern/АТОЛ Коммуникационный модуль (WiFi).jpg",
                price: "",
                text: 'АТОЛ Коммуникационный модуль (WiFi)'
            });
            
            
            this.tarifAdd({
                url: "кассовое-оборудование",
                name: "КассовоеОборудование",
                title: "Кассовое оборудование",
                goods: goods
            });
            
            
            
            goods.push({
                name: "Cканер Honeywell 1470g",
                title: "Cканер Honeywell 1470g",
                group: "torg-obor-scaners",
                imgSmall: "/img/1c/goods/torg-obor/Cканер Honeywell 1470g-small.jpg",
                img: "/img/1c/goods/torg-obor/Cканер Honeywell 1470g.jpg",
                price: "",
                text: 'Cканер Voyage Extreme Performance (XP) 1470g — экономичное решение для сканирования двумерных штрихкодов на предприятиях розничной торговли. Он обеспечивает надежное считывание как традиционных печатных штрихкодов, включая поврежденные и трудно различимые, так и кодов с экранов цифровых устройств.<br><br>Voyager XP 1470g предназначен для считывания линейных и двумерных штрихкодов в рабочих процессах, требующих от сканеров повышенной надежности и долговечности. Увеличенная глубина поля сканирования Voyager XP позволяет считывать штрихкоды с товаров, расположенных в нижней части тележки. Это экономит время в точке продажи, а кассиру приходится меньше нагибаться.<br><br>Устройство выдерживает до 30 падений с высоты 1,8 м и 1000 ударов при падении с высоты 0,5 м. Этот сканер создан в расчете на интенсивное сканирование в точках продаж и обеспечивает повышенную точность считывания даже при сканировании на максимальной дальности.'
            });
            
            goods.push({
                name: "Сканер GlobalPOS GP 3300",
                title: "Сканер GlobalPOS GP 3300",
                group: "torg-obor-scaners",
                imgSmall: "/img/1c/goods/torg-obor/Сканер GlobalPOS GP 3300-small.jpg",
                img: "/img/1c/goods/torg-obor/Сканер GlobalPOS GP 3300.jpg",
                price: "",
                text: 'GP-3300 – бюджетная модель проводного сканера с 2D считывателем. Устройство спроектировано для работы в рознице, здравоохранении (в сети аптек) и государственном секторе. Устройство отлично считывает штрих-коды высокой плотности 3 mil и подойдет для работы с POS-оборудованием. Сканер быстро и точно распознает стандартные 1D/2D штрих-коды.<br><br>GP-3300 легко переключается между ручным и автоматическим режимом считывания. Сканер изготовлен из ударопрочного ABS-пластика с добавлением поликарбоната и весит 129г.<br>Сканер прошел успешное тестирование по считыванию двумерных кодов используемых в системе Маркировка "Честный знак" и может использоваться для ЕГАИС, ФГИС (учет алкогольной и табачной продукции).'
            });
            
            goods.push({
                name: "Проводной сканер штрих-кода MERTECH 2310 P2D HR SUPERLEAD USB",
                title: "Проводной сканер штрих-кода MERTECH 2310 P2D HR SUPERLEAD USB",
                group: "torg-obor-scaners",
                imgSmall: "/img/1c/goods/torg-obor/Проводной сканер штрих-кода MERTECH 2310 P2D HR SUPERLEAD USB-small.jpg",
                img: "/img/1c/goods/torg-obor/Проводной сканер штрих-кода MERTECH 2310 P2D HR SUPERLEAD USB.jpg",
                price: "",
                text: 'Корпус прибора изготовлен из ударопрочного пластика и поликарбоната. Цвет пластика: черный. Размер считывателя: 170*95*70 мм. Прибор весит 125 грамм. Многократные падения с высоты 2 м не влияют на работу электронной начинки. Уровень защиты корпуса от внешних воздействий: IP54.<br><br>Основные характеристики MERTECH 2310:<br><br>Дистанция распознавания этикетки: 57 см.<br>Сканирование со скоростью 100 скан/сек.<br>Сканирующий модуль с разрешением 1280*1080 пикселей.<br>Угол охвата: 38,5°x32,5°.<br>Ресурс триггера: 5 миллионов срабатываний.<br>Чувствительность: наклон 65°, поворот 360°, отклонение 60°.<br>Минимальное разрешение считывания: 3.9 MIL.<br><br>Подключение к онлайн-кассе, смарт-терминалу или компьютеру проводится через USB-HID. Также опционально доступны интерфейсы USB-COM, RS232. Устройство подключается к онлайн-кассам Атол Сигма, Эвотор, Штрих-М, Меркурий и других известных брендов.'
            });
            
            goods.push({
                name: "Сканер штрих-кода MERTECH SUNMI NS021 (sense)",
                title: "Сканер штрих-кода MERTECH SUNMI NS021 (sense)",
                group: "torg-obor-scaners",
                imgSmall: "/img/1c/goods/torg-obor/Сканер штрих-кода MERTECH SUNMI NS021 (sense)-small.jpg",
                img: "/img/1c/goods/torg-obor/Сканер штрих-кода MERTECH SUNMI NS021 (sense).jpg",
                price: "",
                text: 'Устройство отличается эргономичным дизайном. Корпус выполнен из прочного АВС-пластика. Есть прозрачная ручка. Габариты корпуса: 160*95*70 мм. Вес прибора 140 грамм. Конструкция выдерживает удары и падения с высоты до 1,5 метров.<br><br>Рабочие характеристики модели:<br><br>Скорость распознавания: до 100 сканов в секунду.<br>Сканирующий модуль: 2D Image.<br>Дальность сканирования: 450 мм.<br>Минимальная контрастность: 30%.<br>Подсветка: 6500К белого цвета.<br>Разрешение экрана: 640*480 пикселей.<br>Уровень пылевлагозащиты: IP 54.<br><br>Для синхронизации применяется USB-HID интерфейс. Опционально доступна синхронизация по USB-COM (с помощью эмуляции). В комплект входит кабель USB type А с длиной провода 150 см.'
            });
            
            goods.push({
                name: "Сканер АТОЛ impulse 12",
                title: "Сканер АТОЛ impulse 12",
                group: "torg-obor-scaners",
                imgSmall: "/img/1c/goods/torg-obor/Сканер АТОЛ impulse 12-small.jpg",
                img: "/img/1c/goods/torg-obor/Сканер АТОЛ impulse 12.jpg",
                price: "",
                text: 'Улучшенная версия ручного 2D сканера разработана компанией АТОЛ специально для работы со всеми видами маркировки. При разработке сканера АТОЛ Impulse 12 использовалась новейшая компонентная база, что позволило довести качество считывания до идеального уровня. АТОЛ Impulse 12 уверенно сканирует все виды штрихкодов, DataMartix, и даже низкоконтрастные и поврежденные штрихкоды.'
            });
            
            goods.push({
                name: "Сканер HONEYWELL MS7580 Genesis USB",
                title: "Сканер HONEYWELL MS7580 Genesis USB",
                group: "torg-obor-scaners",
                imgSmall: "/img/1c/goods/torg-obor/Сканер HONEYWELL MS7580 Genesis USB-small.jpg",
                img: "/img/1c/goods/torg-obor/Сканер HONEYWELL MS7580 Genesis USB.jpg",
                price: "",
                text: 'Honeywell Metrologic MS7580 MK7580-30C38-02-A Genesis 2D USB – это оптический сканер штрихкода настольного размещения, является многоплоскостным. Сканирует в режиме 1D, 2D и PDF, имеется демонстрационный режим.'
            });
            
            goods.push({
                name: "Сканер Zebra (Symbol) DS4308-HD7U2100AZW USB Black",
                title: "Сканер Zebra (Symbol) DS4308-HD7U2100AZW USB Black",
                group: "torg-obor-scaners",
                imgSmall: "/img/1c/goods/torg-obor/Сканер Zebra (Symbol) DS4308-HD7U2100AZW USB Black-small.jpg",
                img: "/img/1c/goods/torg-obor/Сканер Zebra (Symbol) DS4308-HD7U2100AZW USB Black.jpg",
                price: "",
                text: 'Портативный сканер DS4308 с технологией сканирования нового поколения обладает непревзойдённой гибкостью конфигурации и превосходной производительностью. Его широчайший диапазон сканирования превышает возможности любого другого сканера в данном классе. Это позволяет сотрудникам работать практически с любыми штрихкодами.<br><br>Модель DS4308 выполняет любые задачи и позволяет сканировать одномерные и двухмерные штрихкоды на электронных и физических носителях, включая бумажные этикетки и пластиковые карты, даже если штрихкоды загрязнены, поцарапаны или плохо напечатаны. Интеллектуальная технология обработки изображений PRZM позволяет практически мгновенно считывать штрихкод при нажатии кнопки сканирования. Это значит, что в работе кассового терминала больше не будет задержек, которые могут привести к образованию очереди, длительному ожиданию и, в конце концов, отказу от покупки. DS4308 — сканер нового класса для широкого спектра новых штрихкодов.'
            });
            
            goods.push({
                name: "Сканер АТОЛ SB2108 Plus USB, без подставки, чёрный",
                title: "Сканер АТОЛ SB2108 Plus USB, без подставки, чёрный",
                group: "torg-obor-scaners",
                imgSmall: "/img/1c/goods/torg-obor/Сканер АТОЛ SB2108 Plus USB, без подставки, чёрный-small.jpg",
                img: "/img/1c/goods/torg-obor/Сканер АТОЛ SB2108 Plus USB, без подставки, чёрный.jpg",
                price: "",
                text: '2D-сканер АТОЛ SB2108 Plus – это улучшенная версия бюджетной модели SB2108. Он отличается новым, высокопроизводительным сканирующим модулем и внешним видом корпуса. Надежность, высокое качество и доступность для пользователей остались неизменны.'
            });
            
            goods.push({
                name: "Сканер HONEYWELL MS1450",
                title: "Сканер HONEYWELL MS1450",
                group: "torg-obor-scaners",
                imgSmall: "/img/1c/goods/torg-obor/Сканер HONEYWELL MS1450-small.jpg",
                img: "/img/1c/goods/torg-obor/Сканер HONEYWELL MS1450.jpg",
                price: "",
                text: '2D сканер HONEYWELL MS1450'
            });
            
            goods.push({
                name: "Сканер HONEYWELL MS1400g",
                title: "Сканер HONEYWELL MS1400g",
                group: "torg-obor-scaners",
                imgSmall: "/img/1c/goods/torg-obor/Сканер HONEYWELL MS1400g-small.jpg",
                img: "/img/1c/goods/torg-obor/Сканер HONEYWELL MS1400g.jpg",
                price: "",
                text: '2D сканер HONEYWELL MS1400g'
            });
            
            
            
            
            goods.push({
                name: "Honeywell PC42t Plus USB/RS232/Ethernet",
                title: "Honeywell PC42t Plus USB/RS232/Ethernet",
                group: "torg-obor-print-etic",
                imgSmall: "/img/1c/goods/torg-obor/Honeywell PC42t Plus USB_RS232_Ethernet-small.jpg",
                img: "/img/1c/goods/torg-obor/Honeywell PC42t Plus USB_RS232_Ethernet.jpg",
                price: "",
                text: 'Honeywell PC42t отличается удивительной компактностью и простотой установки, а подготовка к печати занимает совсем мало времени. Благодаря низкому уровню шума, надежной работе и элегантному дизайну PC42t отлично подходит для небольших объемов печати этикеток в самых разных отраслях.'
            });
            
            goods.push({
                name: "Термопринтер TSC-TDP-225",
                title: "Термопринтер TSC-TDP-225",
                group: "torg-obor-print-etic",
                imgSmall: "/img/1c/goods/torg-obor/Термопринтер TSC-TDP-225-small.jpg",
                img: "/img/1c/goods/torg-obor/Термопринтер TSC-TDP-225.jpg",
                price: "",
                text: 'Термопринтер TSC-TDP-225'
            });
            
            
            
            goods.push({
                name: "Денежный ящик",
                title: "Денежный ящик",
                group: "torg-obor-den-yashik",
                imgSmall: "/img/1c/goods/torg-obor/Денежный ящик-small.jpg",
                img: "/img/1c/goods/torg-obor/Денежный ящик.jpg",
                price: "",
                text: 'Денежный ящик (цвет на заказ)'
            });
            
            
            
            goods.push({
                name: "Мобильный терминал АТОЛ SMART.Lite",
                title: "Мобильный терминал АТОЛ SMART.Lite",
                group: "torg-obor-term-sbora",
                imgSmall: "/img/1c/goods/torg-obor/Мобильный терминал АТОЛ SMART.Lite-small.jpg",
                img: "/img/1c/goods/torg-obor/Мобильный терминал АТОЛ SMART.Lite.jpg",
                price: "",
                text: 'Android 7.0, 2D Imager SE4710, 4”, 2Гбх16Гб, Wi-Fi b/g/n, 5200 mAh, Bluetooth, БП'
            });
            
            
            
            goods.push({
                name: "Термоэтикетки 43х25",
                title: "Термоэтикетки 43х25",
                group: "torg-obor-rash-mat",
                imgSmall: "/img/1c/goods/torg-obor/Термоэтикетки 43х25-small.jpg",
                img: "/img/1c/goods/torg-obor/Термоэтикетки 43х25.jpg",
                price: "",
                text: 'Термоэтикетки 43х25'
            });
            
            goods.push({
                name: "Термоэтикетки 20х30",
                title: "Термоэтикетки 20х30",
                group: "torg-obor-rash-mat",
                imgSmall: "/img/1c/goods/torg-obor/Термоэтикетки 20х30-small.jpg",
                img: "/img/1c/goods/torg-obor/Термоэтикетки 20х30.jpg",
                price: "",
                text: 'Термоэтикетки 20х30'
            });
            
            goods.push({
                name: "58х40 Термотрансферные этикетки 700шт/рул",
                title: "58х40 Термотрансферные этикетки 700шт/рул",
                group: "torg-obor-rash-mat",
                imgSmall: "/img/1c/goods/torg-obor/58х40 Термотрансферные этикетки 700шт_рул-small.jpg",
                img: "/img/1c/goods/torg-obor/58х40 Термотрансферные этикетки 700шт_рул.jpg",
                price: "",
                text: '58х40 Термотрансферные этикетки 700шт/рул'
            });
            
            goods.push({
                name: "58х60 Термотрансферные этикетки 500 эт/рул",
                title: "58х60 Термотрансферные этикетки 500 эт/рул",
                group: "torg-obor-rash-mat",
                imgSmall: "/img/1c/goods/torg-obor/58х60 Термотрансферные этикетки 500 эт_рул-small.jpg",
                img: "/img/1c/goods/torg-obor/58х60 Термотрансферные этикетки 500 эт_рул.jpg",
                price: "",
                text: '58х60 Термотрансферные этикетки 500 эт/рул'
            });
            
            goods.push({
                name: "Термоэтикетки 40х60  (вертик.)",
                title: "Термоэтикетки 40х60  (вертик.)",
                group: "torg-obor-rash-mat",
                imgSmall: "/img/1c/goods/torg-obor/Термоэтикетки 40х60  (вертик.)-small.jpg",
                img: "/img/1c/goods/torg-obor/Термоэтикетки 40х60  (вертик.).jpg",
                price: "",
                text: 'Термоэтикетки 40х60  (вертик.)'
            });
            
            this.tarifAdd({
                url: "торговое-оборудование",
                name: "ТорговоеОборудование",
                title: "Торговое оборудование",
                goods: goods
            });
            
            
            
            goods.push({
                name: "Эл. подпись для работы с ЕГАИС (алкоголь, ФСРАР)",
                title: "Эл. подпись для работы с ЕГАИС (алкоголь, ФСРАР)",
                group: "ecp",
                imgSmall: "/img/1c/goods/ecp/Эл. подпись для работы с ЕГАИС (алкоголь, ФСРАР)-small.jpg",
                img: "/img/1c/goods/ecp/Эл. подпись для работы с ЕГАИС (алкоголь, ФСРАР).jpg",
                price: "",
                text: 'Эл. подпись для работы с ЕГАИС (алкоголь, ФСРАР)'
            });
            
            goods.push({
                name: "Эл. подпись для участия в торгах по 44-ФЗ и 223-ФЗ",
                title: "Эл. подпись для участия в торгах по 44-ФЗ и 223-ФЗ",
                group: "ecp",
                imgSmall: "/img/1c/goods/ecp/Эл. подпись для участия в торгах по 44-ФЗ и 223-ФЗ-small.jpg",
                img: "/img/1c/goods/ecp/Эл. подпись для участия в торгах по 44-ФЗ и 223-ФЗ.jpg",
                price: "",
                text: 'Эл. подпись для участия в торгах по 44-ФЗ и 223-ФЗ'
            });
            
            goods.push({
                name: "Эл. подпись для работы с маркировкой (ЦРПТ или Честный знак)",
                title: "Эл. подпись для работы с маркировкой (ЦРПТ или Честный знак)",
                group: "ecp",
                imgSmall: "/img/1c/goods/ecp/Эл. подпись для работы с маркировкой (ЦРПТ или Честный знак)-small.jpg",
                img: "/img/1c/goods/ecp/Эл. подпись для работы с маркировкой (ЦРПТ или Честный знак).jpg",
                price: "",
                text: 'Эл. подпись для работы с маркировкой (ЦРПТ или Честный знак)'
            });
            
            
            
            /*
            goods.push({
                name: "Рутокен Lite 64КБ ндв4, серт. ФСТЭК + Комплект документации ФСТЭК 3753 (оуд4)",
                title: "Рутокен Lite 64КБ ндв4, серт. ФСТЭК + Комплект документации ФСТЭК 3753 (оуд4)",
                group: "ecp-tokens",
                imgSmall: "/img/1c/goods/ecp/Рутокен Lite 64КБ ндв4, серт. ФСТЭК плюс комплект документации ФСТЭК-small.jpg",
                img: "/img/1c/goods/ecp/Рутокен Lite 64КБ ндв4, серт. ФСТЭК плюс комплект документации ФСТЭК.jpg",
                price: "",
                text: 'Рутокен Lite — это линейка защищенных носителей базового уровня для ключей УКЭП. Устройства не требуют установки специальных драйверов и готовы к работе сразу после подключения к компьютеру.<br><br>Рутокен Lite совместимы с отечественными программными СКЗИ (криптопровайдерами) в основных операционных системах. Могут использоваться в качестве идентификаторов в программных, программно-аппаратных и аппаратных СЗИ. Устройства сертифицированы ФСТЭК России. В поставку сертифицированной версии Рутокен Lite micro входит вся необходимая документация, подтверждающая отсутствие программных закладок и недекларированных возможностей.'
            });
            */
            
            goods.push({
                name: "Рутокен Lite 64КБ ндв4, серт. ФСТЭК",
                title: "Рутокен Lite 64КБ ндв4, серт. ФСТЭК",
                group: "ecp-tokens",
                imgSmall: "/img/1c/goods/ecp/Рутокен Lite 64КБ ндв4, серт. ФСТЭК-small.jpg",
                img: "/img/1c/goods/ecp/Рутокен Lite 64КБ ндв4, серт. ФСТЭК.jpg",
                price: "2 100",
                text: 'Рутокен Lite — это линейка защищенных носителей базового уровня для ключей УКЭП. Устройства не требуют установки специальных драйверов и готовы к работе сразу после подключения к компьютеру.<br><br>Рутокен Lite совместимы с отечественными программными СКЗИ (криптопровайдерами) в основных операционных системах. Могут использоваться в качестве идентификаторов в программных, программно-аппаратных и аппаратных СЗИ. Устройства сертифицированы ФСТЭК России. В поставку сертифицированной версии Рутокен Lite micro входит вся необходимая документация, подтверждающая отсутствие программных закладок и недекларированных возможностей.'
            });
            
            goods.push({
                name: "Рутокен ЭЦП 3.0 64КБ, серт. ФСБ (ЕГАИС)",
                title: "Рутокен ЭЦП 3.0 64КБ, серт. ФСБ (ЕГАИС)",
                group: "ecp-tokens",
                imgSmall: "/img/1c/goods/ecp/Рутокен ЭЦП 2.0 64КБ, серт. ФСБ (ЕГАИС)-small.jpg",
                img: "/img/1c/goods/ecp/Рутокен ЭЦП 2.0 64КБ, серт. ФСБ (ЕГАИС).jpg",
                price: "3 400",
                text: 'Электронный идентификатор с аппаратной реализацией российских стандартов электронной подписи, шифрования и хеширования. Обеспечивает безопасное хранение ключей электронной подписи во встроенной защищенной памяти без возможности их экспорта.<br><br>Устройство обладает поддержкой отечественных криптографических стандартов: ГОСТ Р 34.10-2012, описывающий алгоритмы формирования и проверки электронной подписи и ГОСТ Р 34.11-2012, определяющий алгоритм и процедуру вычисления хеш-функции, и алгоритма выработки парного ключа VKO ГОСТ Р 34.10-2012.'
            });
            
            this.tarifAdd({
                url: "электронные-подписи",
                name: "ЭлектронныеПодписи",
                title: "Электронные подписи",
                goods: goods
            });
            
            
            
            
            
            goods.push({
                name: "ПИН-код активации кассы в Астрал ОФД на 1 мес.",
                title: "ПИН-код активации кассы в Астрал ОФД на 1 мес.",
                group: "ofd",
                imgSmall: "/img/1c/goods/ofd/ПИН-код активации кассы в Астрал ОФД на 1 мес.-small.jpg",
                img: "/img/1c/goods/ofd/ПИН-код активации кассы в Астрал ОФД на 1 мес..jpg",
                price: "375",
                text: 'ПИН-код активации кассы в Астрал ОФД на 1 мес.'
            });
            
            goods.push({
                name: "ПИН-код активации кассы в Астрал ОФД на 3 мес.",
                title: "ПИН-код активации кассы в Астрал ОФД на 3 мес.",
                group: "ofd",
                imgSmall: "/img/1c/goods/ofd/ПИН-код активации кассы в Астрал ОФД на 3 мес.-small.jpg",
                img: "/img/1c/goods/ofd/ПИН-код активации кассы в Астрал ОФД на 3 мес..jpg",
                price: "1100",
                text: 'ПИН-код активации кассы в Астрал ОФД на 3 мес.'
            });
            
            goods.push({
                name: "ПИН-код активации кассы в Астрал ОФД на 6 мес.",
                title: "ПИН-код активации кассы в Астрал ОФД на 6 мес.",
                group: "ofd",
                imgSmall: "/img/1c/goods/ofd/ПИН-код активации кассы в Астрал ОФД на 6 мес.-small.jpg",
                img: "/img/1c/goods/ofd/ПИН-код активации кассы в Астрал ОФД на 6 мес..jpg",
                price: "2 200",
                text: 'ПИН-код активации кассы в Астрал ОФД на 6 мес.'
            });
            
            goods.push({
                name: "ПИН-код активации кассы в Астрал ОФД на 13 мес.",
                title: "ПИН-код активации кассы в Астрал ОФД на 13 мес.",
                group: "ofd",
                imgSmall: "/img/1c/goods/ofd/ПИН-код активации кассы в Астрал ОФД на 13 мес.-small.jpg",
                img: "/img/1c/goods/ofd/ПИН-код активации кассы в Астрал ОФД на 13 мес..jpg",
                price: "4 000",
                text: 'ПИН-код активации кассы в Астрал ОФД на 13 мес.'
            });
            
            goods.push({
                name: "ПИН-код активации кассы в Астрал ОФД на 15 мес.",
                title: "ПИН-код активации кассы в Астрал ОФД на 15 мес.",
                group: "ofd",
                imgSmall: "/img/1c/goods/ofd/ПИН-код активации кассы в Астрал ОФД на 15 мес.-small.jpg",
                img: "/img/1c/goods/ofd/ПИН-код активации кассы в Астрал ОФД на 15 мес..jpg",
                price: "4 500",
                text: 'ПИН-код активации кассы в Астрал ОФД на 15 мес.'
            });
            
            goods.push({
                name: "ПИН-код активации кассы в Астрал ОФД на 36 мес.",
                title: "ПИН-код активации кассы в Астрал ОФД на 36 мес.",
                group: "ofd",
                imgSmall: "/img/1c/goods/ofd/ПИН-код активации кассы в Астрал ОФД на 36 мес.-small.jpg",
                img: "/img/1c/goods/ofd/ПИН-код активации кассы в Астрал ОФД на 36 мес..jpg",
                price: "9 500",
                text: 'ПИН-код активации кассы в Астрал ОФД на 36 мес.'
            });
            
            this.tarifAdd({
                url: "офд",
                name: "ОФД",
                title: "ОФД",
                goods: goods
            });
            
            
            
            goods.push({
                name: "Kaspersky Internet Security Russian Edition. 2-Device 1 year Renewal Card",
                title: "Kaspersky Internet Security Russian Edition. 2-Device 1 year Renewal Card",
                group: "antivirus-kasp",
                imgSmall: "/img/1c/goods/antivirus/Kaspersky Internet Security Russian Edition. 2-Device 1 year Renewal Card-small.jpg",
                img: "/img/1c/goods/antivirus/Kaspersky Internet Security Russian Edition. 2-Device 1 year Renewal Card.jpg",
                price: "",
                text: 'Ключ продления лицензии Kaspersky Internet Security на год на 2 устройства'
            });
            
            goods.push({
                name: "Kaspersky Internet Security Russian Edition. 2-Device 1 year Base Box",
                title: "Kaspersky Internet Security Russian Edition. 2-Device 1 year Base Box",
                group: "antivirus-kasp",
                imgSmall: "/img/1c/goods/antivirus/Kaspersky Internet Security Russian Edition. 2-Device 1 year Base Box-small.jpg",
                img: "/img/1c/goods/antivirus/Kaspersky Internet Security Russian Edition. 2-Device 1 year Base Box.jpg",
                price: "",
                text: 'Лицензия Kaspersky Internet Security на год на 2 устройства'
            });
            
            goods.push({
                name: "Kaspersky Internet Security Russian Edition. 3-Device 1 year Base Box",
                title: "Kaspersky Internet Security Russian Edition. 3-Device 1 year Base Box",
                group: "antivirus-kasp",
                imgSmall: "/img/1c/goods/antivirus/Kaspersky Internet Security Russian Edition. 3-Device 1 year Base Box-small.jpg",
                img: "/img/1c/goods/antivirus/Kaspersky Internet Security Russian Edition. 3-Device 1 year Base Box.jpg",
                price: "",
                text: 'Лицензия Kaspersky Internet Security на год на 3 устройства'
            });
            
            goods.push({
                name: "Kaspersky Internet Security Russian Edition. 5-Device 1 year Base Box",
                title: "Kaspersky Internet Security Russian Edition. 5-Device 1 year Base Box",
                group: "antivirus-kasp",
                imgSmall: "/img/1c/goods/antivirus/Kaspersky Internet Security Russian Edition. 5-Device 1 year Base Box-small.jpg",
                img: "/img/1c/goods/antivirus/Kaspersky Internet Security Russian Edition. 5-Device 1 year Base Box.jpg",
                price: "",
                text: 'Лицензия Kaspersky Internet Security на год на 5 устройств'
            });
            
            /*
            goods.push({
                name: "",
                title: "",
                group: "",
                imgSmall: "/img/1c/goods/1c/-small.jpg",
                img: "/img/1c/goods/1c/.jpg",
                price: "",
                text: ''
            });
            */
            
            this.tarifAdd({
                url: "антивирусное-по",
                name: "АнтивирусноеПО",
                title: "Антивирусное ПО",
                goods: goods
            });
            
            for(let i = 0; i < this.tarifs.length; i++){
                
                let tarifCur = this.tarifs[i];
                
                if(tarifCur.url === this.httpPathCurrentPage.slice(-tarifCur.url.length)){
                    tarif = tarifCur;
                    break;
                }
                
            }
            
            this.groups = [];
            
            let group = null;
            
            if(tarif.url === "продукция-1с"){
                
                group = this.groupAdd({
                    name: "bp",
                    title: "Бухгалтерия предприятия"
                });

                this.groupAdd({
                    name: "zup",
                    title: "Зарплата и управление персоналом"
                });

                this.groupAdd({
                    name: "trade",
                    title: "Управление торговлей"
                });

                this.groupAdd({
                    name: "unf",
                    title: "Управление нашей фирмой"
                });

                this.groupAdd({
                    name: "retail",
                    title: "Розница"
                });

                this.groupAdd({
                    name: "lic",
                    title: "Лицензии"
                });

                this.groupAdd({
                    name: "1c-otchetnost",
                    title: "1С Отчётность"
                });
                
            }
            else if(tarif.url === "кассовое-оборудование"){
                
                group = this.groupAdd({
                    name: "kkt-mobile",
                    title: "Автономные ККТ"
                });
                
                this.groupAdd({
                    name: "kkt-fr",
                    title: "Фискальные регистраторы"
                });
                
                this.groupAdd({
                    name: "kkt-fn",
                    title: "Фискальные накопители"
                });
                
                this.groupAdd({
                    name: "kkt-services",
                    title: "Обслуживание ККТ"
                });
                
                this.groupAdd({
                    name: "kkt-rash-mat",
                    title: "Расходные материалы"
                });
                
                this.groupAdd({
                    name: "kkt-modern",
                    title: "Модернизация ККТ"
                });
                
            }    
            else if(tarif.url === "торговое-оборудование"){
                
                group = this.groupAdd({
                    name: "torg-obor-scaners",
                    title: "Сканеры штрих-кодов"
                });
                
                this.groupAdd({
                    name: "torg-obor-print-etic",
                    title: "Принтеры печати этикеток"
                });
                
                this.groupAdd({
                    name: "torg-obor-den-yashik",
                    title: "Денежные ящики"
                });
                
                this.groupAdd({
                    name: "torg-obor-term-sbora",
                    title: "Терминалы сбора данных"
                });
                
                this.groupAdd({
                    name: "torg-obor-rash-mat",
                    title: "Расходные материалы"
                });
                
            }
            else if(tarif.url === "электронные-подписи"){
                
                group = this.groupAdd({
                    name: "ecp",
                    title: "Электронные подписи"
                });
                
                this.groupAdd({
                    name: "ecp-tokens",
                    title: "Носители электронных подписей"
                });
                
            }
            else if(tarif.url === "офд"){
                
                group = this.groupAdd({
                    name: "ofd",
                    title: "ОФД"
                });
                
            }
            else if(tarif.url === "антивирусное-по"){
                
                group = this.groupAdd({
                    name: "antivirus-kasp",
                    title: "Антивирус Касперского"
                });
                
            }
            
            this.setTarifActive(tarif);
            
            this.setGroupActive(group);
            
        },
        tarifAdd(tarif){
            
            let id = this.tarifs.length;
            
            tarif['id'] = id;
            tarif['backgroundColor'] = "";
            
            this.tarifs.push(tarif);
            
            return tarif;
            
        },
        groupAdd(group){
            
            let id = this.groups.length;
            
            group['id'] = id;
            group['backgroundColor'] = "";
            
            this.groups.push(group);
            
            return group;
            
        },
        setGroupActive(group){
            
            this.groupActive = group;
            
            for(let i = 0; i < this.groups.length; i++){
                
                let groupCur = this.groups[i];
                
                if(groupCur === this.groupActive){
                    groupCur.backgroundColor = "#9999ff";
                }else{
                    groupCur.backgroundColor = "#ffff66";
                }
                
            }
            
            this.updateTarifsInTable();
            
            var myElement = document.getElementById('mainDiv');
            myElement.scrollTo(0, 0);
    
        },
        updateTarifsInTable(){
            
            this.tarifsInTable = [];
            
            let row = null;
            
            for(let i = 0; i < this.tarifActive.goods.length; i++){
                
                let product = this.tarifActive.goods[i];
                
                if(product.group !== this.groupActive.name){
                    continue;
                }
                
                if(row === null || row.columns.length >= this.tarifsInTableColumns){
                    row = {
                        id: i,
                        columns: []
                    };
                    this.tarifsInTable.push(row);
                    
                }
                
                row.columns.push({
                    id: row.columns.length,
                    product: product
                });
                
            }
            
        },
        productDivShow: function(product){
            this.productDiv.product = product;
            this.productDiv.visible = true;
        },
        productDivClose: function(){
            this.productDiv.visible = false;
        },
        setTarifActive(tarif){
            
            this.tarifActive = tarif;
            
            for(let i = 0; i < this.tarifs.length; i++){
                
                let tarifCur = this.tarifs[i];
                
                if(tarifCur === this.tarifActive){
                    tarifCur.backgroundColor = "#9999ff";
                }else{
                    tarifCur.backgroundColor = "#ffff66";
                }
                
            }
    
        },
        goToHref: function(href){
            this.$router.push(href);
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
    #tarifsMenu {
        
        border: 0px solid blue;
        
        float: left;
        
        cursor: pointer;
        
        text-align: center;
        font-weight: bold;
        
        margin-bottom: 10px;
        border-radius: 5px;
        
        padding-top: 5px;
        padding-bottom: 5px;
        
    }
    
    td {
        padding: 5px;
    }
    
    .close {
        position: absolute;
        cursor: pointer;
        right: 10px;
        top: 5px;
        width: 32px;
        height: 32px;
        opacity: 0.3;
    }
    .close:hover {
        opacity: 1;
    }
    .close:before, .close:after {
        position: absolute;
        left: 15px;
        content: ' ';
        height: 33px;
        width: 2px;
        background-color: #333;
    }
    .close:before {
        transform: rotate(45deg);
    }
    .close:after {
        transform: rotate(-45deg);
    }    
    
</style>

